import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
} from "reactstrap";
import Header from "../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

// (2026-10) Campo de catálogo con buscador: se escribe y filtra. value / onChange
// trabajan con el _id, igual que el select que reemplaza.
function Buscador({ value, onChange, opciones, etiqueta }) {
  const lista = (opciones || [])
    .slice()
    .sort((a, b) => String(etiqueta(a) || "").localeCompare(String(etiqueta(b) || ""), "es", { sensitivity: "base" }));
  const elegido = lista.find((o) => String(o._id) === String(value)) || null;
  return (
    <Autocomplete
      size="small"
      value={elegido}
      options={lista}
      getOptionLabel={(o) => String(etiqueta(o) || "")}
      getOptionSelected={(o, v) => String(o._id) === String(v._id)}
      onChange={(e, o) => onChange(o ? o._id : "")}
      noOptionsText="Sin coincidencias"
      renderInput={(params) => (
        <TextField {...params} placeholder="Selecciona o escribe para buscar" variant="outlined" />
      )}
    />
  );
}
// (2026-10) muestra para un cliente o para un prospecto del CRM
const datoTxt = (v) => (v && String(v).trim().toUpperCase() !== "NA" ? String(v).trim() : "");
const nombreProspecto = (p) => (p ? datoTxt(p.empresa) || datoTxt(p.razon_social) : "");
const clienteDeMuestra = (m) =>
  m?.clientes?.[0]?.nombre_comercial ||
  (m?.crmProspectos?.[0] ? `${nombreProspecto(m.crmProspectos[0])} (Prospecto)` : "");
const nombreTalla = (t) => `${t.name || ""}${t.variantesTallas?.[0]?.name ? ` ${t.variantesTallas[0].name}` : ""}`;

// ============================================================================
// MÓDULO MUESTRAS (2026-07)
// Todo en UNA sola vista, con 2 pestañas:
//   1) MUESTRAS   -> registrar la muestra POR LÍNEA (no por artículo), asignarle
//                    tela (estilo ListadoOrdenesCorte), sacarle habilitación
//                    (estilo ListadoCortes) y TERMINARLA.
//   2) INVENTARIO -> existencias de muestras terminadas, con Entradas y
//                    Salidas a clientes.
// Proceso 100% interno: no hay maquileros/proveedores.
// ============================================================================
function Muestras() {
  const { user } = useContext(AuthContext);

  const URL_MUESTRAS = process.env.REACT_APP_URL_MUESTRAS;
  const URL_MUESTRAS_INVENTARIO = process.env.REACT_APP_URL_MUESTRAS_INVENTARIO;
  const URL_MUESTRAS_TELAS = process.env.REACT_APP_URL_MUESTRAS_TELAS;
  const URL_MUESTRAS_HABILITACION = process.env.REACT_APP_URL_MUESTRAS_HABILITACION;
  const URL_MUESTRAS_MOVIMIENTOS = process.env.REACT_APP_URL_MUESTRAS_MOVIMIENTOS;
  const URL_MUESTRAS_PENDIENTES = `${process.env.REACT_APP_URL_MUESTRAS_MOVIMIENTOS}Pendientes`;
  const URL_SUB_DEPARTAMENTOS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_MUESTRAS_COMPRAS = process.env.REACT_APP_URL_MUESTRAS_COMPRAS;
  const URL_MUESTRAS_TRASPASO = process.env.REACT_APP_URL_MUESTRAS_TRASPASO;
  // (2026-08) Imágenes de la muestra (archivo en Cloudinary + observación propia)
  const URL_MUESTRAS_IMAGENES = process.env.REACT_APP_URL_MUESTRAS_IMAGENES;
  const URL_UPMEDIA = process.env.REACT_APP_URL_UPMEDIA;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const hoy = moment().format("YYYY-MM-DD");

  // ---------------- Pestañas ----------------
  const [tab, setTab] = useState("muestras"); // muestras | inventario

  // ---------------- Catálogos ----------------
  const [lineas, setLineas] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [rollosTela, setRollosTela] = useState([]);
  const [stockHabilitacion, setStockHabilitacion] = useState([]);

  // ---------------- Datos ----------------
  const [muestras, setMuestras] = useState([]);
  const [inventario, setInventario] = useState([]);
  const [search, setSearch] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");

  // ---------------- Modal: nueva / editar muestra ----------------
  const [modalMuestra, setModalMuestra] = useState(false);
  const [idEdit, setIdEdit] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [linea, setLinea] = useState("");
  const [color, setColor] = useState("");
  const [talla, setTalla] = useState("");
  const [cliente, setCliente] = useState("");
  // (2026-10) la muestra también puede ser para un prospecto del CRM
  const [destinoMuestra, setDestinoMuestra] = useState("cliente"); // cliente | prospecto
  const [prospectoMuestra, setProspectoMuestra] = useState("");
  const [prospectos, setProspectos] = useState([]);
  const [descripcion, setDescripcion] = useState("");
  // (2026-08) Tela de la muestra: texto libre
  const [telaMuestra, setTelaMuestra] = useState("");
  // (2026-08) Departamento (DAMA / CABALLERO...) del catálogo
  const [departamentos, setDepartamentos] = useState([]);
  const [departamento, setDepartamento] = useState("");
  // (2026-08) Vendedor de la muestra (colaboradores)
  const [vendedorMuestra, setVendedorMuestra] = useState("");
  // (2026-08) Datos que se capturan al terminar la muestra
  const [modalTerminar, setModalTerminar] = useState(false);
  const [muestraTerminar, setMuestraTerminar] = useState(null);
  // (2026-10) true = sólo corregir Cortó / Confeccionó / horas de una ya terminada
  const [editandoTerminar, setEditandoTerminar] = useState(false);
  const [corto, setCorto] = useState("");
  const [confecciono, setConfecciono] = useState("");
  const [fhInicio, setFhInicio] = useState("");
  const [fhFin, setFhFin] = useState("");
  // (2026-08) Año (temporada) de la muestra
  const [anio, setAnio] = useState(String(new Date().getFullYear()));
  const [cantidad, setCantidad] = useState(1);
  const [observaciones, setObservaciones] = useState("");

  // ---------------- Modal: tela / habilitación ----------------
  const [modalTela, setModalTela] = useState(false);
  const [modalHab, setModalHab] = useState(false);
  // (2026-08) Galería de imágenes de la muestra
  const [modalImgs, setModalImgs] = useState(false);
  const [muestraImgs, setMuestraImgs] = useState(null);
  const [imagenes, setImagenes] = useState([]);
  const [archivosImg, setArchivosImg] = useState([]);
  const [obsImg, setObsImg] = useState("");
  const [subiendoImg, setSubiendoImg] = useState(false);
  const [muestraSel, setMuestraSel] = useState(null);
  // (2026-08) Cuando la salida de material es para una COMPRA de muestra
  const [compraMat, setCompraMat] = useState(null);
  const [telasMuestra, setTelasMuestra] = useState([]);
  const [habMuestra, setHabMuestra] = useState([]);
  const [rolloSel, setRolloSel] = useState("");
  const [cantTela, setCantTela] = useState(0);
  // Escaneo del rollo (el QR trae el _id del rollo, igual que en ListadoOrdenesCorte)
  const [scanRollo, setScanRollo] = useState("");
  const [rolloInfo, setRolloInfo] = useState(null);
  const [invHabSel, setInvHabSel] = useState("");
  const [cantHab, setCantHab] = useState(0);

  // ---------------- Modal: movimiento de inventario ----------------
  const [modalMov, setModalMov] = useState(false);
  const [movTipo, setMovTipo] = useState("Salida");
  const [movMuestra, setMovMuestra] = useState(null);
  const [movCantidad, setMovCantidad] = useState(1);
  const [movCliente, setMovCliente] = useState("");
  const [movObs, setMovObs] = useState("");
  const [movHistorial, setMovHistorial] = useState([]);
  // Reporte: salidas con muestras que el cliente NO ha regresado
  const [pendientes, setPendientes] = useState([]);
  // (2026-07) T2 — vendedor (colaborador) que entrega la muestra
  const [colaboradores, setColaboradores] = useState([]);
  const [movVendedor, setMovVendedor] = useState("");
  // (2026-08) Precio de la muestra en la salida
  const [movPrecio, setMovPrecio] = useState(0);
  // Filtro de vendedor en el reporte "Sin Regresar"
  const [filtroVendedor, setFiltroVendedor] = useState("");

  // (2026-07) T3 — traspaso de stock normal al inventario de muestras
  const [modalTraspaso, setModalTraspaso] = useState(false);
  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [traspArticulo, setTraspArticulo] = useState("");
  const [traspArea, setTraspArea] = useState("");
  const [traspDetalle, setTraspDetalle] = useState([]);
  const [traspCombo, setTraspCombo] = useState("");
  const [traspCantidad, setTraspCantidad] = useState(1);

  // (2026-07) T4 — compra de muestras (OC + recepción que genera CxP)
  const [compras, setCompras] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [modalCompra, setModalCompra] = useState(false);
  const [cpProveedor, setCpProveedor] = useState("");
  const [cpLinea, setCpLinea] = useState("");
  const [cpColor, setCpColor] = useState("");
  const [cpTalla, setCpTalla] = useState("");
  const [cpDescripcion, setCpDescripcion] = useState("");
  // (2026-08) Tela que se le pide al proveedor (texto libre)
  const [cpTela, setCpTela] = useState("");
  // (2026-08) Cliente para el que se manda hacer la muestra
  const [cpCliente, setCpCliente] = useState("");
  // (2026-08) Compra en edición (vacío = alta nueva)
  const [idEditCompra, setIdEditCompra] = useState("");
  const [cpCantidad, setCpCantidad] = useState(1);
  const [cpPrecio, setCpPrecio] = useState(0);
  const [cpIva, setCpIva] = useState("No");
  const [cpObs, setCpObs] = useState("");

  const nombreMuestra = (m) =>
    `${m?.subDepartamentos?.[0]?.name || "Sin Línea"}${
      m?.descripcion && m.descripcion !== "NA" ? " - " + m.descripcion : ""
    }`;

  // Vendedor (colaborador) que hizo la salida
  const nombreVendedor = (mov) => {
    const c = mov?.colaboradores?.[0];
    if (!c) return "Sin vendedor";
    return `${c.nombre || ""} ${c.apellido || ""}`.trim() || "Sin vendedor";
  };
  const idVendedor = (mov) => String(mov?.colaboradores?.[0]?._id || "SIN");

  // Vendedores que aparecen en el reporte (para el filtro)
  const vendedoresPendientes = pendientes
    .reduce((acc, p) => {
      const id = idVendedor(p);
      if (!acc.some((v) => v.id === id)) acc.push({ id, nombre: nombreVendedor(p) });
      return acc;
    }, [])
    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1));

  const pendientesFiltrados = filtroVendedor
    ? pendientes.filter((p) => idVendedor(p) === filtroVendedor)
    : pendientes;

  // ======================= CARGA =======================
  // arr(): si la variable de entorno no existe (p.ej. falta en netlify.toml)
  // axios pega a la propia página y regresa el index.html; sin esto el string
  // se guardaría en el state y la vista truena en blanco.
  const arr = (d) => (Array.isArray(d) ? d : []);

  const cargaMuestras = () => {
    axios
      .get(URL_MUESTRAS, { headers })
      .then((r) => setMuestras(arr(r.data)))
      .catch((e) => console.log(e));
  };
  const cargaInventario = () => {
    axios
      .get(URL_MUESTRAS_INVENTARIO, { headers })
      .then((r) => setInventario(arr(r.data)))
      .catch((e) => console.log(e));
  };
  const cargaPendientes = () => {
    axios
      .get(URL_MUESTRAS_PENDIENTES, { headers })
      .then((r) => setPendientes(arr(r.data)))
      .catch((e) => console.log(e));
  };
  const cargaCompras = () => {
    axios
      .get(URL_MUESTRAS_COMPRAS, { headers })
      .then((r) => setCompras(arr(r.data)))
      .catch((e) => console.log(e));
  };

  // ---------- T1: cambiar status (Sin Empezar <-> Proceso) ----------
  const cambiaStatus = async (m, status) => {
    try {
      await axios.patch(`${URL_MUESTRAS}/status/${m._id}`, { status }, { headers });
      cargaMuestras();
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo cambiar"}`, "error");
    }
  };

  // ---------- T3: traspaso de stock -> muestras ----------
  const abreTraspaso = () => {
    setTraspArticulo("");
    setTraspArea("");
    setTraspDetalle([]);
    setTraspCombo("");
    setTraspCantidad(1);
    setModalTraspaso(true);
  };

  const cargaDetalleTraspaso = async (articulo, area) => {
    if (!articulo || !area) {
      setTraspDetalle([]);
      return;
    }
    try {
      const r = await axios.get(
        `${URL_INVENTARIOS}ArticuloAreaDetalle/${articulo}/${area}`,
        { headers }
      );
      setTraspDetalle(arr(r.data).filter((d) => Number(d.cantidad || 0) > 0));
      setTraspCombo("");
    } catch (e) {
      console.log(e);
      setTraspDetalle([]);
    }
  };

  const guardaTraspaso = async () => {
    const combo = traspDetalle.find((d) => d._id === traspCombo);
    if (!combo) return Swal.fire("Falta el combo", "Selecciona color/talla", "warning");
    if (Number(traspCantidad) <= 0)
      return Swal.fire("Cantidad inválida", "Captura una cantidad mayor a 0", "warning");
    if (Number(traspCantidad) > Number(combo.cantidad))
      return Swal.fire("Sin existencia", `Solo hay ${combo.cantidad} pzas`, "warning");
    try {
      await axios.post(
        URL_MUESTRAS_TRASPASO,
        {
          articulos: traspArticulo,
          colores: combo.colores?.[0]?._id,
          tallas: combo.tallas?.[0]?._id,
          areas: traspArea,
          cantidad: Number(traspCantidad),
          fecha: hoy,
          ...(user?.id ? { user: user.id } : {}),
        },
        { headers }
      );
      setModalTraspaso(false);
      cargaMuestras();
      cargaInventario();
      Swal.fire("Listo", "Piezas traspasadas al inventario de muestras", "success");
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo traspasar"}`, "error");
    }
  };

  // ---------- T4: compra de muestras ----------
  const abreCompra = () => {
    setIdEditCompra("");
    setCpProveedor("");
    setCpLinea("");
    setCpColor("");
    setCpTalla("");
    setCpDescripcion("");
    setCpTela("");
    setCpCliente("");
    setCpCantidad(1);
    setCpPrecio(0);
    setCpIva("No");
    setCpObs("");
    setModalCompra(true);
  };

  // (2026-08) Editar la orden mientras siga Pendiente
  const abreEditaCompra = (c) => {
    if (c.status === "Recibida") {
      return Swal.fire(
        "Compra recibida",
        "Ya no se puede editar: generó la muestra y su CxP.",
        "warning"
      );
    }
    setIdEditCompra(c._id);
    setCpProveedor(c.proveedores?.[0]?._id || "");
    setCpLinea(c.subDepartamentos?.[0]?._id || "");
    setCpColor(c.colores?.[0]?._id || "");
    setCpTalla(c.tallas?.[0]?._id || "");
    setCpDescripcion(c.descripcion && c.descripcion !== "NA" ? c.descripcion : "");
    setCpTela(c.tela && c.tela !== "NA" ? c.tela : "");
    setCpCliente(c.clientes?.[0]?._id || "");
    setCpCantidad(c.cantidad || 1);
    setCpPrecio(c.precio || 0);
    setCpIva(c.iva || "No");
    setCpObs(c.observaciones && c.observaciones !== "NA" ? c.observaciones : "");
    setModalCompra(true);
  };

  const guardaCompra = async () => {
    if (!cpProveedor) return Swal.fire("Falta el proveedor", "Selecciona el proveedor", "warning");
    if (!cpLinea) return Swal.fire("Falta la línea", "Selecciona la línea", "warning");
    if (Number(cpCantidad) <= 0)
      return Swal.fire("Cantidad inválida", "Captura una cantidad mayor a 0", "warning");
    try {
      const body = {
          ...(idEditCompra ? {} : { fecha: hoy }),
          proveedores: cpProveedor,
          ...(cpCliente ? { clientes: cpCliente } : {}),
          subDepartamentos: cpLinea,
          ...(cpColor ? { colores: cpColor } : {}),
          ...(cpTalla ? { tallas: cpTalla } : {}),
          descripcion: cpDescripcion || "NA",
          tela: cpTela || "NA",
          cantidad: Number(cpCantidad),
          precio: Number(cpPrecio) || 0,
          iva: cpIva,
          observaciones: cpObs || "NA",
          ...(user?.id ? { user: user.id } : {}),
      };
      if (idEditCompra) {
        await axios.patch(`${URL_MUESTRAS_COMPRAS}/${idEditCompra}`, body, { headers });
      } else {
        await axios.post(URL_MUESTRAS_COMPRAS, body, { headers });
      }
      setModalCompra(false);
      setIdEditCompra("");
      cargaCompras();
      Swal.fire(
        "Listo",
        idEditCompra ? "Orden de compra actualizada" : "Orden de compra de muestra creada",
        "success"
      );
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo crear"}`, "error");
    }
  };

  // (2026-08) Ticket de la recepción de la compra: comprobante chico (80mm)
  // para pegar/archivar o dárselo a quien entregó la muestra.
  const TicketRecepcion = (c) => {
    const t = (v) => (v === undefined || v === null || v === "NA" ? "" : String(v));
    const money = (v) =>
      new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
        Number(v || 0)
      );

    const cant = Number(c.cantidad || 0);
    const precio = Number(c.precio || 0);
    const subtotal = cant * precio;
    const iva = c.iva === "Si" ? subtotal * 0.16 : 0;
    const total = subtotal + iva;

    const W = 80; // ancho de ticket
    const doc = new jsPDF({ unit: "mm", format: [W, 200] });
    const ML = 5;
    const ancho = W - ML * 2;
    let y = 8;

    const centrado = (txt, size = 9, bold = false) => {
      doc.setFont("helvetica", bold ? "bold" : "normal").setFontSize(size);
      doc.text(String(txt), W / 2, y, { align: "center" });
      y += size * 0.5 + 1.5;
    };
    const linea = () => {
      doc.setLineWidth(0.2);
      doc.setDrawColor(150);
      doc.line(ML, y, W - ML, y);
      y += 3;
    };
    const fila = (etq, val, bold = false) => {
      doc.setFont("helvetica", "normal").setFontSize(8);
      doc.text(String(etq), ML, y);
      doc.setFont("helvetica", bold ? "bold" : "normal");
      doc.text(String(val), W - ML, y, { align: "right" });
      y += 4.5;
    };

    try {
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
      const h = 9;
      doc.addImage(img, "png", (W - h * 2.4) / 2, y - 4, h * 2.4, h);
      y += h + 1;
    } catch (e) {}

    centrado("RECEPCIÓN DE MUESTRA", 10, true);
    centrado(`Compra #${t(c.idMuestrasCompra)}`, 9, true);
    linea();

    fila("Fecha recepción:", t(c.fechaRecepcion) || hoy);
    fila("Proveedor:", (t(c.proveedores?.[0]?.nombre_comercial) || "—").slice(0, 22));
    if (t(c.clientes?.[0]?.nombre_comercial))
      fila("Cliente:", t(c.clientes[0].nombre_comercial).slice(0, 22));
    fila("Línea:", (t(c.subDepartamentos?.[0]?.name) || "—").slice(0, 22));
    if (t(c.descripcion)) fila("Modelo:", t(c.descripcion).slice(0, 22));
    if (t(c.tela)) fila("Tela:", t(c.tela).slice(0, 22));
    fila("Color / Talla:",
      [t(c.colores?.[0]?.name), t(c.tallas?.[0]?.name)].filter(Boolean).join(" / ") || "—");
    linea();

    fila("Piezas:", String(cant), true);
    fila("Precio unitario:", money(precio));
    fila("Subtotal:", money(subtotal));
    fila(`IVA (${c.iva === "Si" ? "16%" : "0%"}):`, money(iva));
    doc.setFont("helvetica", "bold").setFontSize(10);
    doc.text("TOTAL", ML, y);
    doc.text(money(total), W - ML, y, { align: "right" });
    y += 6;
    linea();

    doc.setFont("helvetica", "normal").setFontSize(7.5);
    const nota = doc.splitTextToSize(
      "La muestra entró al inventario de muestras y se generó la NotaCxP del proveedor.",
      ancho
    );
    doc.text(nota, ML, y);
    y += nota.length * 3.2 + 6;

    // firma de quien recibe
    doc.setDrawColor(120);
    doc.line(ML + 6, y, W - ML - 6, y);
    y += 4;
    doc.setFontSize(7.5);
    doc.text("Recibió", W / 2, y, { align: "center" });
    y += 6;
    doc.setFontSize(7);
    doc.setTextColor(120);
    doc.text(moment().format("YYYY-MM-DD HH:mm"), W / 2, y, { align: "center" });

    window.open(doc.output("bloburl"), "_blank");
  };

  // (2026-10) Cancelar la compra. Si ya se recibió, el back deshace la muestra
  // (sale del inventario) y la CxP; no deja si ya tiene pagos.
  const cancelaCompra = (c) => {
    const avisoMaterial =
      "<small>El material que se le entregó al proveedor (tela / habilitación) no se regresa solo.</small>";
    Swal.fire({
      title: `¿Cancelar la compra #${c.idMuestrasCompra}?`,
      html:
        c.status === "Recibida"
          ? `Ya se recibió: la muestra sale del inventario y se cancela la CxP de ${
              c.proveedores?.[0]?.nombre_comercial || "el proveedor"
            }.<br/>${avisoMaterial}`
          : avisoMaterial,
      icon: "warning",
      input: "text",
      inputPlaceholder: "Motivo de la cancelación",
      inputValidator: (v) => (!String(v || "").trim() ? "Escribe el motivo" : undefined),
      showCancelButton: true,
      confirmButtonText: "Sí, cancelar compra",
      cancelButtonText: "No",
    }).then(async (res) => {
      if (!res.isConfirmed) return;
      try {
        await axios.patch(
          `${URL_MUESTRAS_COMPRAS}/cancelar/${c._id}`,
          { motivo: String(res.value || "").trim() },
          { headers }
        );
        cargaCompras();
        cargaMuestras();
        cargaInventario();
        cargaPendientes();
        Swal.fire("Cancelada", `La compra #${c.idMuestrasCompra} quedó cancelada`, "success");
      } catch (err) {
        Swal.fire("No se pudo cancelar", `${err?.response?.data || "Intenta de nuevo"}`, "error");
      }
    });
  };

  const recibeCompra = (c) => {
    const subtotal = Number(c.cantidad || 0) * Number(c.precio || 0);
    const iva = c.iva === "Si" ? subtotal * 0.16 : 0;
    Swal.fire({
      title: `¿Recibir la compra #${c.idMuestrasCompra}?`,
      html: `Entran <b>${c.cantidad}</b> pzas al inventario de muestras.<br/>
             Se genera la <b>CxP</b> a ${c.proveedores?.[0]?.nombre_comercial || "el proveedor"} por
             <b>${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(subtotal + iva)}</b>${
        c.iva === "Si" ? " (IVA incluido)" : ""
      }.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, recibir",
      cancelButtonText: "Cancelar",
    }).then(async (res) => {
      if (!res.isConfirmed) return;
      try {
        await axios.patch(
          `${URL_MUESTRAS_COMPRAS}/recibir/${c._id}`,
          { fecha: hoy, ...(user?.id ? { user: user.id } : {}) },
          { headers }
        );
        cargaCompras();
        cargaMuestras();
        cargaInventario();
        const r2 = await Swal.fire({
          title: "Compra recibida",
          text: "La muestra entró al inventario y se generó la CxP. ¿Descargar el ticket de recepción?",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Sí, ticket",
          cancelButtonText: "No, gracias",
        });
        if (r2.isConfirmed) {
          TicketRecepcion({ ...c, status: "Recibida", fechaRecepcion: hoy });
        }
      } catch (err) {
        Swal.fire("Error", `${err?.response?.data || "No se pudo recibir"}`, "error");
      }
    });
  };

  useEffect(() => {
    cargaMuestras();
    cargaInventario();
    cargaPendientes();
    axios.get(URL_SUB_DEPARTAMENTOS, { headers }).then((r) => setLineas(arr(r.data))).catch(() => {});
    axios.get(URL_DEPARTAMENTOS, { headers }).then((r) => setDepartamentos(arr(r.data))).catch(() => {});
    axios.get(URL_COLORES, { headers }).then((r) => setColores(arr(r.data))).catch(() => {});
    axios.get(URL_TALLAS, { headers }).then((r) => setTallas(arr(r.data))).catch(() => {});
    axios.get(URL_CLIENTES, { headers }).then((r) => setClientes(arr(r.data))).catch(() => {});
    axios
      .get(process.env.REACT_APP_URL_CRM_PROSPECTOS, { headers })
      .then((r) => setProspectos(arr(r.data).filter((p) => p.is_active !== "No" && !p.cliente)))
      .catch(() => {});
    cargaCompras();
    axios.get(URL_COLABORADORES, { headers }).then((r) => setColaboradores(arr(r.data))).catch(() => {});
    axios.get(URL_PROVEEDORES, { headers }).then((r) => setProveedores(arr(r.data))).catch(() => {});
    axios.get(URL_ARTICULOS, { headers }).then((r) => setArticulos(arr(r.data))).catch(() => {});
    axios.get(URL_AREAS, { headers }).then((r) => setAreas(arr(r.data))).catch(() => {});
  }, []);

  // ======================= NUEVA / EDITAR MUESTRA =======================
  const limpiaForm = () => {
    setIdEdit("");
    setFecha(hoy);
    setAnio(String(hoy).slice(0, 4));
    setLinea("");
    setColor("");
    setTalla("");
    setCliente("");
    setDestinoMuestra("cliente");
    setProspectoMuestra("");
    setDescripcion("");
    setTelaMuestra("");
    setDepartamento("");
    setVendedorMuestra("");
    setCantidad(1);
    setObservaciones("");
  };

  const abreNueva = () => {
    limpiaForm();
    setModalMuestra(true);
  };

  const abreEdita = (m) => {
    setIdEdit(m._id);
    setFecha(m.fecha || hoy);
    setAnio(m.anio || String(m.fecha || hoy).slice(0, 4));
    setLinea(m.subDepartamentos?.[0]?._id || "");
    setColor(m.colores?.[0]?._id || "");
    setTalla(m.tallas?.[0]?._id || "");
    setCliente(m.clientes?.[0]?._id || "");
    const pro = !m.clientes?.[0] ? m.crmProspectos?.[0] : null;
    setDestinoMuestra(pro ? "prospecto" : "cliente");
    setProspectoMuestra(pro?._id || "");
    setDescripcion(m.descripcion && m.descripcion !== "NA" ? m.descripcion : "");
    setTelaMuestra(m.tela && m.tela !== "NA" ? m.tela : "");
    setDepartamento(m.departamentos?.[0]?._id || "");
    setVendedorMuestra(m.colaboradores?.[0]?._id || "");
    setCantidad(m.cantidad || 0);
    setObservaciones(m.observaciones && m.observaciones !== "NA" ? m.observaciones : "");
    setModalMuestra(true);
  };

  const guardaMuestra = async () => {
    if (!linea) return Swal.fire("Falta la línea", "Selecciona la línea de la muestra", "warning");
    const body = {
      fecha,
      anio: String(anio || "").trim() || String(fecha || "").slice(0, 4),
      subDepartamentos: linea,
      ...(departamento ? { departamentos: departamento } : {}),
      ...(vendedorMuestra ? { colaboradores: vendedorMuestra } : {}),
      ...(color ? { colores: color } : {}),
      ...(talla ? { tallas: talla } : {}),
      // (2026-10) cliente o prospecto; al editar, el otro se limpia
      ...(destinoMuestra === "prospecto"
        ? prospectoMuestra
          ? { crmProspectos: prospectoMuestra, ...(idEdit ? { clientes: null } : {}) }
          : {}
        : cliente
        ? { clientes: cliente, ...(idEdit ? { crmProspectos: null } : {}) }
        : {}),
      descripcion: descripcion || "NA",
      tela: telaMuestra || "NA",
      cantidad: Number(cantidad) || 0,
      observaciones: observaciones || "NA",
      ...(user?.id ? { user: user.id } : {}),
    };
    try {
      if (idEdit) await axios.patch(`${URL_MUESTRAS}/${idEdit}`, body, { headers });
      else await axios.post(URL_MUESTRAS, body, { headers });
      setModalMuestra(false);
      limpiaForm();
      cargaMuestras();
      cargaInventario();
      Swal.fire("Listo", idEdit ? "Muestra actualizada" : "Muestra registrada", "success");
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo guardar"}`, "error");
    }
  };

  // (2026-08) Al terminar se capturan Corto / Confeccionó / inicio y fin
  const terminaMuestra = (m, soloEditar = false) => {
    setEditandoTerminar(!!soloEditar);
    setMuestraTerminar(m);
    setCorto(m.corto || "");
    setConfecciono(m.confecciono || "");
    setFhInicio(m.fechaHoraInicio || "");
    setFhFin(m.fechaHoraFin || (soloEditar ? "" : moment().format("YYYY-MM-DDTHH:mm")));
    setModalTerminar(true);
  };

  const confirmaTerminar = async () => {
    if (!muestraTerminar) return;
    // (2026-10) ya terminada: sólo se corrigen los datos (no vuelve a entrar al inventario)
    if (editandoTerminar) {
      try {
        await axios.patch(
          `${URL_MUESTRAS}/${muestraTerminar._id}`,
          {
            corto: corto || "",
            confecciono: confecciono || "",
            fechaHoraInicio: fhInicio || "",
            fechaHoraFin: fhFin || "",
          },
          { headers }
        );
        setModalTerminar(false);
        setMuestraTerminar(null);
        cargaMuestras();
        Swal.fire("Listo", "Datos de la muestra actualizados", "success");
      } catch (err) {
        Swal.fire("Error", `${err?.response?.data || "No se pudo guardar"}`, "error");
      }
      return;
    }
    try {
      await axios.patch(
        `${URL_MUESTRAS}/terminar/${muestraTerminar._id}`,
        {
          fecha: hoy,
          cantidad: muestraTerminar.cantidad,
          corto: corto || "",
          confecciono: confecciono || "",
          fechaHoraInicio: fhInicio || "",
          fechaHoraFin: fhFin || "",
          ...(user?.id ? { user: user.id } : {}),
        },
        { headers }
      );
      setModalTerminar(false);
      setMuestraTerminar(null);
      cargaMuestras();
      cargaInventario();
      Swal.fire("Listo", "Muestra terminada y agregada al inventario", "success");
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo terminar"}`, "error");
    }
  };

  const bajaMuestra = (m) => {
    Swal.fire({
      title: `¿Dar de baja la muestra ${m.idMuestra}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, dar de baja",
      cancelButtonText: "Cancelar",
    }).then(async (res) => {
      if (!res.isConfirmed) return;
      await axios.patch(`${URL_MUESTRAS}/baja/${m._id}`, { is_active: "No" }, { headers });
      cargaMuestras();
      cargaInventario();
    });
  };


  // (2026-08) La salida también se puede saldar PAGÁNDOLA: el cliente se queda
  // con la muestra. No regresa al inventario, solo deja de estar pendiente.
  const registraPago = async (salida) => {
    const pendiente = Number(salida.pendiente ?? salida.cantidad ?? 0);
    const { value: form } = await Swal.fire({
      title: "¿Cuántas pagó?",
      html:
        `<div style="display:flex;gap:12px;justify-content:center;text-align:left">` +
        `<div style="flex:1">` +
        `<label for="sw-cant" style="font-size:13px;font-weight:600;color:#545454">Piezas</label>` +
        `<input id="sw-cant" type="number" class="swal2-input" style="margin:4px 0 0;width:100%" value="${pendiente}" min="1" max="${pendiente}">` +
        `<small style="color:#888">Pendiente: ${pendiente}</small>` +
        `</div>` +
        `<div style="flex:1">` +
        `<label for="sw-precio" style="font-size:13px;font-weight:600;color:#545454">Precio unitario</label>` +
        `<input id="sw-precio" type="number" step="any" class="swal2-input" style="margin:4px 0 0;width:100%" value="${Number(
          salida.precio || 0
        )}">` +
        `<small style="color:#888">${
          salida.clientes?.[0]?.nombre_comercial || "Cliente"
        }</small>` +
        `</div>` +
        `</div>`,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Registrar pago",
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const c = Number(document.getElementById("sw-cant")?.value || 0);
        const p = Number(document.getElementById("sw-precio")?.value || 0);
        if (!c || c <= 0) {
          Swal.showValidationMessage("Captura una cantidad mayor a 0");
          return false;
        }
        if (c > pendiente) {
          Swal.showValidationMessage(`Solo hay ${pendiente} por saldar`);
          return false;
        }
        return { cantidad: c, precio: p };
      },
    });
    if (!form) return;
    try {
      await axios.patch(
        `${URL_MUESTRAS_MOVIMIENTOS}/pagar/${salida._id}`,
        { cantidad: form.cantidad, precio: form.precio, fechaPago: hoy },
        { headers }
      );
      if (movMuestra) {
        const r = await axios.get(
          `${URL_MUESTRAS_MOVIMIENTOS}/muestra/${movMuestra._id}`,
          { headers }
        );
        setMovHistorial(arr(r.data));
      }
      cargaInventario();
      cargaPendientes();
      Swal.fire("Listo", "Pago registrado", "success");
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo registrar"}`, "error");
    }
  };

  // ======================= PDF CONSUMO Y HABILITACIÓN =======================
  // (2026-08) Formato de papel pero SIN líneas para llenar a mano: los consumos
  // de tela y habilitación salen del sistema (lo realmente entregado y su
  // consumo por pieza). Solo quedan los recuadros para pegar las muestras
  // físicas: telas, hilo y botón.
  const PDFConsumo = async (m) => {
    try {
      const [rt, rh] = await Promise.all([
        axios.get(`${URL_MUESTRAS_TELAS}/muestra/${m._id}`, { headers }),
        axios.get(`${URL_MUESTRAS_HABILITACION}/muestra/${m._id}`, { headers }),
      ]);
      const telasM = arr(rt.data);
      const habsM = arr(rh.data);

      const doc = new jsPDF("p", "mm", "a4");
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const ML = 14;
      const contentW = pageW - ML * 2;

      // ---- paleta corporativa (misma de los demás PDFs) ----
      const brandColor = [42, 90, 138];
      const lightBg = [245, 247, 250];
      const borderColor = [210, 216, 224];
      const labelColor = [110, 120, 135];

      const t = (v) => (v === undefined || v === null || v === "NA" ? "" : String(v));
      const fh = (v) => t(v).replace("T", " ");
      const n2 = (v) => Number(v || 0).toFixed(2);

      const piezas = Number(m.cantidad || 0) || 1;
      const t0 = telasM[0] || {};
      const telaCat = t0.telas?.[0] || {};
      const nomTela = t(m.tela) || t(telaCat.nombre);
      const totalTela = telasM.reduce((a, x) => a + Number(x.cantidad || 0), 0);
      const totalHab = habsM.reduce((a, x) => a + Number(x.cantidad || 0), 0);
      const cliente = t(clienteDeMuestra(m));
      const vendedor = `${t(m.colaboradores?.[0]?.nombre)} ${t(
        m.colaboradores?.[0]?.apellido
      )}`.trim();

      // ================= ENCABEZADO =================
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
      await new Promise((resolve) => {
        img.onload = () => {
          const maxH = 14;
          const w = img.width * (maxH / img.height);
          doc.addImage(img, "png", ML, 8, w, maxH);
          resolve();
        };
        img.onerror = () => resolve();
      });

      doc.setFont(undefined, "bold").setFontSize(16);
      doc.setTextColor(...brandColor);
      doc.text(`Muestra ${t(m.idMuestra)}${m.anio ? `   ·   Año ${t(m.anio)}` : ""}`, pageW - ML, 15, { align: "right" });
      doc.setFont(undefined, "normal").setFontSize(9.5);
      doc.setTextColor(...labelColor);
      // doc.text(
      //   `Muestra ${t(m.idMuestra)}${m.anio ? `   ·   Año ${t(m.anio)}` : ""}`,
      //   pageW - ML,
      //   21,
      //   { align: "right" }
      // );
      doc.setTextColor(0);
      doc.setDrawColor(...brandColor).setLineWidth(0.6);
      doc.line(ML, 25, pageW - ML, 25);
      doc.setLineWidth(0.2).setDrawColor(0);

      // ================= CARD DE DATOS =================
      // (2026-08) El card se arma midiendo cada valor contra el ancho que le toca:
      // lo que no cabe se parte en renglones y el card crece, así los textos
      // largos (Prenda, Composición...) ya no se enciman con la columna de junto.
      const cardY = 28;
      const colA = ML + 3, colAv = ML + 24;
      const colB = ML + 66, colBv = ML + 92;
      const colC = ML + 130, colCv = ML + 154;
      const paso = 5.6;
      const lineH = 4;

      const columnas = [
        {
          lblX: colA,
          valX: colAv,
          ancho: colB - colAv - 3,
          campos: [
            ["Cliente:", cliente],
            ["Modelo:", t(m.descripcion)],
            ["Prenda:", t(m.subDepartamentos?.[0]?.name)],
            ["Talla:", t(m.tallas?.[0]?.name)],
            ["Género:", t(m.departamentos?.[0]?.name)],
          ],
        },
        {
          lblX: colB,
          valX: colBv,
          ancho: colC - colBv - 3,
          campos: [
            ["Tela:", nomTela],
            ["Color:", t(m.colores?.[0]?.name) || t(t0.colores?.[0]?.name)],
            ["Composición:", t(telaCat.composicion)],
            ["Ancho:", t(telaCat.ancho)],
            ["Piezas:", t(m.cantidad)],
          ],
        },
        {
          lblX: colC,
          valX: colCv,
          ancho: pageW - ML - 3 - colCv,
          campos: [
            ["F. Corte:", t(m.fecha)],
            ["Vendedor:", vendedor],
            ["Cortó:", t(m.corto)],
            ["Confeccionó:", t(m.confecciono)],
            ["Terminada:", t(m.fechaTerminada)],
          ],
        },
      ];

      // medir con la misma tipografía con la que se va a imprimir el valor
      doc.setFont(undefined, "normal").setFontSize(9);
      const columnasMedidas = columnas.map((c) => ({
        ...c,
        campos: c.campos.map(([lbl, val]) => ({
          lbl,
          lineas: doc
            .splitTextToSize(String(val ?? "").trim() || "—", c.ancho)
            .slice(0, 2),
        })),
      }));

      const altoCampo = (f) => Math.max(paso, f.lineas.length * lineH + 1.2);
      const cardH =
        Math.max(
          ...columnasMedidas.map((c) =>
            c.campos.reduce((a, f) => a + altoCampo(f), 0)
          )
        ) + 11; // + la franja de tiempos de abajo

      doc.setDrawColor(...borderColor).setFillColor(...lightBg);
      doc.roundedRect(ML, cardY, contentW, cardH, 1.5, 1.5, "FD");
      doc.setDrawColor(0);

      const y0 = cardY + 6;
      columnasMedidas.forEach((c) => {
        let yy = y0;
        c.campos.forEach((f) => {
          doc.setFont(undefined, "bold").setFontSize(8);
          doc.setTextColor(...labelColor);
          doc.text(f.lbl, c.lblX, yy);
          doc.setFont(undefined, "normal").setFontSize(9);
          doc.setTextColor(0);
          f.lineas.forEach((ln, i) => doc.text(ln, c.valX, yy + i * lineH));
          yy += altoCampo(f);
        });
      });

      // Franja de tiempos dentro del card
      doc.setFont(undefined, "bold").setFontSize(8.5);
      doc.setTextColor(...brandColor);
      doc.text(
        `Inicio: ${fh(m.fechaHoraInicio) || "—"}          Término: ${fh(m.fechaHoraFin) || "—"}`,
        colA,
        cardY + cardH - 3
      );
      doc.setTextColor(0).setFont(undefined, "normal");

      // ================= SECCIONES =================
      // si no cabe el bloque en lo que queda de hoja, abre página nueva
      const asegura = (yy, alto) => {
        if (yy + alto > pageH - 16) {
          doc.addPage();
          return 20;
        }
        return yy;
      };

      const seccion = (titulo, y) => {
        doc.setFillColor(...brandColor);
        doc.rect(ML, y, contentW, 6, "F");
        doc.setFont(undefined, "bold").setFontSize(9);
        doc.setTextColor(255);
        doc.text(titulo, ML + 3, y + 4.2);
        doc.setTextColor(0).setFont(undefined, "normal");
        return y + 6;
      };

      const tablaBase = {
        margin: { left: ML, right: ML },
        theme: "grid",
        styles: { fontSize: 8, cellPadding: 1.8, lineColor: borderColor, lineWidth: 0.1 },
        headStyles: { fillColor: lightBg, textColor: 40, fontStyle: "bold", fontSize: 8 },
        alternateRowStyles: { fillColor: [251, 252, 253] },
        footStyles: { fillColor: [226, 233, 241], textColor: 20, fontStyle: "bold" },
      };

      // ---- CONSUMO DE TELA ----
      let y = seccion("CONSUMO DE TELA", cardY + cardH + 7);
      doc.autoTable({
        ...tablaBase,
        startY: y,
        columnStyles: {
          0: { cellWidth: 66 },
          1: { cellWidth: 40 },
          2: { halign: "right" },
          3: { halign: "right" },
        },
        head: [["TELA", "COLOR", "ENTREGADO", "CONSUMO X PZA"]],
        body: telasM.length
          ? telasM.map((x) => [
              t(x.telas?.[0]?.nombre) || "—",
              t(x.colores?.[0]?.name) || "—",
              `${n2(x.cantidad)} ${t(x.unidad) || "mts"}`,
              n2(Number(x.cantidad || 0) / piezas),
            ])
          : [[{ content: "Sin tela registrada", colSpan: 4, styles: { halign: "center", textColor: labelColor } }]],
        foot: telasM.length
          ? [["TOTAL", "", `${n2(totalTela)} mts`, n2(totalTela / piezas)]]
          : undefined,
      });

      // ---- HABILITACIÓN ----
      y = seccion("HABILITACIÓN ENTREGADA", (doc.lastAutoTable?.finalY || y) + 7);
      doc.autoTable({
        ...tablaBase,
        startY: y,
        columnStyles: {
          0: { cellWidth: 106 },
          1: { halign: "right" },
          2: { halign: "right" },
        },
        head: [["HABILITACIÓN", "ENTREGADO", "CONSUMO X PZA"]],
        body: habsM.length
          ? habsM.map((x) => [
              t(x.habilitacion?.[0]?.descripcion) || t(x.habilitacion?.[0]?.name) || "—",
              n2(x.cantidad),
              n2(Number(x.cantidad || 0) / piezas),
            ])
          : [[{ content: "Sin habilitación registrada", colSpan: 3, styles: { halign: "center", textColor: labelColor } }]],
        foot: habsM.length ? [["TOTAL", n2(totalHab), n2(totalHab / piezas)]] : undefined,
      });

      // ---- OBSERVACIONES ----
      y = (doc.lastAutoTable?.finalY || y) + 7;
      if (t(m.observaciones)) {
        y = seccion("OBSERVACIONES", asegura(y, 22));
        const txt = doc.splitTextToSize(t(m.observaciones), contentW - 6).slice(0, 3);
        const h = txt.length * 4.5 + 3;
        doc.setDrawColor(...borderColor).setFillColor(255);
        doc.rect(ML, y, contentW, h, "FD");
        doc.setFontSize(8.5).setTextColor(60);
        doc.text(txt, ML + 3, y + 5);
        doc.setTextColor(0);
        y += h + 7;
      }

      // ---- RECUADROS PARA PEGAR LAS MUESTRAS ----
      y = seccion("MUESTRAS FÍSICAS", asegura(y, 50));
      const boxH = Math.max(40, Math.min(62, pageH - 22 - y));
      const gap = 4;
      const wTela = 74;
      const wResto = (contentW - wTela - gap * 2) / 2;
      const cajas = [
        { x: ML, w: wTela, label: "TELAS" },
        { x: ML + wTela + gap, w: wResto, label: "N° DE HILO" },
        { x: ML + wTela + gap + wResto + gap, w: wResto, label: "MUESTRA DE BOTÓN" },
      ];
      cajas.forEach((c) => {
        doc.setDrawColor(...borderColor).setFillColor(255).setLineWidth(0.3);
        doc.roundedRect(c.x, y + 2, c.w, boxH, 1.5, 1.5, "FD");
        // etiqueta de la caja
        doc.setFillColor(...lightBg);
        doc.rect(c.x, y + 2, c.w, 6, "F");
        doc.setFont(undefined, "bold").setFontSize(7.5).setTextColor(...brandColor);
        doc.text(c.label, c.x + c.w / 2, y + 6.2, { align: "center" });
        doc.setFont(undefined, "normal").setFontSize(7).setTextColor(...labelColor);
        doc.text("pegar muestra", c.x + c.w / 2, y + 2 + boxH / 2, { align: "center" });
        doc.setTextColor(0);
      });
      doc.setLineWidth(0.2);

      // ---- PIE ----
      const paginas = doc.internal.getNumberOfPages();
      for (let p = 1; p <= paginas; p++) {
        doc.setPage(p);
        doc.setDrawColor(...borderColor).setLineWidth(0.2);
        doc.line(ML, pageH - 12, pageW - ML, pageH - 12);
        doc.setFontSize(7.5).setTextColor(...labelColor);
        doc.text(
          `Muestra ${t(m.idMuestra)}${cliente ? `  ·  ${cliente}` : ""}`,
          ML,
          pageH - 8
        );
        doc.text(`Página ${p} de ${paginas}`, pageW - ML, pageH - 8, { align: "right" });
        doc.setTextColor(0);
      }

      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "No se pudo generar el PDF", "error");
    }
  };


  // ======================= PDF TELA ENTREGADA =======================
  // (2026-08) Comprobante de la tela que se entregó. Sale desde el modal de
  // tela, que es el mismo para la muestra y para la compra de muestra.
  const PDFTelaEntregada = async () => {
    const ref = compraMat || muestraSel;
    if (!ref) return;
    if (!telasMuestra.length)
      return Swal.fire("Sin tela", "Esta muestra no tiene tela entregada", "warning");

    try {
      const esCompra = !!compraMat;

      const doc = new jsPDF("p", "mm", "a4");
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const ML = 14;
      const contentW = pageW - ML * 2;

      const brandColor = [42, 90, 138];
      const lightBg = [245, 247, 250];
      const borderColor = [210, 216, 224];
      const labelColor = [110, 120, 135];

      const t = (v) => (v === undefined || v === null || v === "NA" ? "" : String(v));
      const n2 = (v) => Number(v || 0).toFixed(2);

      const cliente = t(clienteDeMuestra(ref));
      const proveedor = t(ref.proveedores?.[0]?.nombre_comercial);
      const total = telasMuestra.reduce((a, x) => a + Number(x.cantidad || 0), 0);
      const modelo = [t(ref.subDepartamentos?.[0]?.name), t(ref.descripcion)]
        .filter((x) => x)
        .join(" - ");

      // (2026-08) Si el valor no cabe en el ancho de su columna se achica la
      // letra (y en el extremo se recorta) para que no se encime con la de junto.
      const drawLabel = (label, value, lblX, valX, y, maxW) => {
        doc.setFont(undefined, "bold").setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(label, lblX, y);
        const texto = String(value ?? "").trim() || "—";
        doc.setFont(undefined, "normal").setTextColor(0);
        let fs = 9;
        doc.setFontSize(fs);
        if (maxW) {
          while (doc.getTextWidth(texto) > maxW && fs > 6.2) {
            fs -= 0.25;
            doc.setFontSize(fs);
          }
          doc.text(doc.splitTextToSize(texto, maxW)[0], valX, y);
        } else {
          doc.text(texto, valX, y);
        }
        doc.setFontSize(9);
      };

      // ================= ENCABEZADO =================
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
      await new Promise((resolve) => {
        img.onload = () => {
          const maxH = 14;
          const w = img.width * (maxH / img.height);
          doc.addImage(img, "png", ML, 8, w, maxH);
          resolve();
        };
        img.onerror = () => resolve();
      });

      doc.setFont(undefined, "bold").setFontSize(16);
      doc.setTextColor(...brandColor);
      doc.text("ENTREGA DE TELA", pageW - ML, 14, { align: "right" });
      doc.setFont(undefined, "normal").setFontSize(9.5);
      doc.setTextColor(...labelColor);
      doc.text(
        esCompra
          ? `Compra ${t(ref.idMuestrasCompra)}`
          : `Muestra ${t(ref.idMuestra)}${ref.anio ? `   ·   Año ${t(ref.anio)}` : ""}`,
        pageW - ML,
        20,
        { align: "right" }
      );
      doc.setTextColor(0);
      doc.setDrawColor(...brandColor).setLineWidth(0.6);
      doc.line(ML, 25, pageW - ML, 25);
      doc.setLineWidth(0.2).setDrawColor(0);

      // ================= CARD DE DATOS =================
      const cardY = 28;
      const cardH = 24;
      doc.setDrawColor(...borderColor).setFillColor(...lightBg);
      doc.roundedRect(ML, cardY, contentW, cardH, 1.5, 1.5, "FD");
      doc.setDrawColor(0);

      const colA = ML + 3,
        colAv = ML + 26;
      const colB = ML + 100,
        colBv = ML + 126;
      const y0 = cardY + 6;
      const paso = 5.6;

      const anchoA = colB - colAv - 3;
      const anchoB = pageW - ML - 3 - colBv;

      drawLabel("Fecha:", hoy, colA, colAv, y0, anchoA);
      drawLabel("Cliente:", cliente, colA, colAv, y0 + paso, anchoA);
      drawLabel("Modelo:", modelo, colA, colAv, y0 + paso * 2, anchoA);

      drawLabel(
        esCompra ? "Proveedor:" : "Talla:",
        esCompra ? proveedor : t(ref.tallas?.[0]?.name),
        colB,
        colBv,
        y0,
        anchoB
      );
      drawLabel("Piezas:", t(ref.cantidad), colB, colBv, y0 + paso, anchoB);
      drawLabel("Total entregado:", `${n2(total)} mts`, colB, colBv, y0 + paso * 2, anchoB);

      // ================= TABLA =================
      doc.setFillColor(...brandColor);
      doc.rect(ML, cardY + cardH + 7, contentW, 6, "F");
      doc.setFont(undefined, "bold").setFontSize(9).setTextColor(255);
      doc.text("TELA ENTREGADA", ML + 3, cardY + cardH + 11.2);
      doc.setTextColor(0).setFont(undefined, "normal");

      doc.autoTable({
        margin: { left: ML, right: ML },
        theme: "grid",
        startY: cardY + cardH + 13,
        styles: { fontSize: 8, cellPadding: 1.8, lineColor: borderColor, lineWidth: 0.1 },
        headStyles: { fillColor: lightBg, textColor: 40, fontStyle: "bold", fontSize: 8 },
        alternateRowStyles: { fillColor: [251, 252, 253] },
        footStyles: { fillColor: [226, 233, 241], textColor: 20, fontStyle: "bold" },
        columnStyles: {
          0: { cellWidth: 22 },
          1: { cellWidth: 44, fontSize: 7 },
          3: { cellWidth: 32 },
          4: { halign: "right", cellWidth: 26 },
        },
        head: [["FECHA", "ROLLO", "TELA", "COLOR", "CANTIDAD"]],
        body: telasMuestra.map((x) => [
          t(x.fecha),
          // el rollo se identifica por su id, igual que en la salida de tela
          // de corte externo (es lo que trae el código escaneado)
          t(x.inventariosTelas?.[0]?.codigo) ||
            t(x.inventariosTelas?.[0]?._id) ||
            "—",
          t(x.telas?.[0]?.nombre) || "—",
          t(x.colores?.[0]?.name) || "—",
          `${n2(x.cantidad)} ${t(x.unidad) || "mts"}`,
        ]),
        foot: [["TOTAL", "", "", "", `${n2(total)} mts`]],
      });

      // ================= FIRMAS (ancladas abajo, sin forzar hoja nueva) =======
      const finTabla = doc.lastAutoTable?.finalY || cardY + cardH;
      let yFirmas = pageH - 34;
      if (finTabla > yFirmas - 8) {
        doc.addPage();
        yFirmas = pageH - 34;
      }
      const anchoF = (contentW - 20) / 2;
      [
        ["ENTREGÓ", ML],
        ["RECIBIÓ", ML + anchoF + 20],
      ].forEach(([txt, x]) => {
        doc.setDrawColor(...borderColor).setLineWidth(0.3);
        doc.line(x, yFirmas, x + anchoF, yFirmas);
        doc.setFont(undefined, "bold").setFontSize(8).setTextColor(...labelColor);
        doc.text(txt, x + anchoF / 2, yFirmas + 4.5, { align: "center" });
        doc.setTextColor(0).setFont(undefined, "normal");
      });
      doc.setLineWidth(0.2);

      // ================= PIE =================
      const paginas = doc.internal.getNumberOfPages();
      for (let p = 1; p <= paginas; p++) {
        doc.setPage(p);
        doc.setDrawColor(...borderColor).setLineWidth(0.2);
        doc.line(ML, pageH - 12, pageW - ML, pageH - 12);
        doc.setFontSize(7.5).setTextColor(...labelColor);
        doc.text(
          `${esCompra ? `Compra ${t(ref.idMuestrasCompra)}` : `Muestra ${t(ref.idMuestra)}`}${
            cliente ? `  ·  ${cliente}` : ""
          }`,
          ML,
          pageH - 8
        );
        doc.text(`Página ${p} de ${paginas}`, pageW - ML, pageH - 8, { align: "right" });
        doc.setTextColor(0);
      }

      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "No se pudo generar el PDF", "error");
    }
  };

  // ======================= PDF ORDEN DE COMPRA DE MUESTRA =======================
  // (2026-08) Documento para mandarle al proveedor, con el mismo formato
  // corporativo que la orden de corte externo. Incluye lo que se le pide y,
  // si se le entregó material, la tela y habilitación que se le dieron.
  const PDFCompra = async (c) => {
    try {
      const [rt, rh] = await Promise.all([
        axios.get(`${URL_MUESTRAS_TELAS}/compra/${c._id}`, { headers }).catch(() => ({ data: [] })),
        axios.get(`${URL_MUESTRAS_HABILITACION}/compra/${c._id}`, { headers }).catch(() => ({ data: [] })),
      ]);
      const telasC = arr(rt.data);
      const habsC = arr(rh.data);

      const doc = new jsPDF("p", "mm", "a4");
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const ML = 14;
      const contentW = pageW - ML * 2;

      const brandColor = [42, 90, 138];
      const lightBg = [245, 247, 250];
      const borderColor = [210, 216, 224];
      const labelColor = [110, 120, 135];

      const t = (v) => (v === undefined || v === null || v === "NA" ? "" : String(v));
      const n2 = (v) => Number(v || 0).toFixed(2);
      const money = (v) =>
        new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
          Number(v || 0)
        );

      const prov = c.proveedores?.[0] || {};
      const cant = Number(c.cantidad || 0);
      const precio = Number(c.precio || 0);
      const subtotal = cant * precio;
      const iva = c.iva === "Si" ? subtotal * 0.16 : 0;
      const total = subtotal + iva;

      // (2026-08) Si el valor no cabe en el ancho de su columna se achica la
      // letra (y en el extremo se recorta) para que no se encime con la de junto.
      const drawLabel = (label, value, lblX, valX, y, maxW) => {
        doc.setFont(undefined, "bold").setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(label, lblX, y);
        const texto = String(value ?? "").trim() || "—";
        doc.setFont(undefined, "normal").setTextColor(0);
        let fs = 9;
        doc.setFontSize(fs);
        if (maxW) {
          while (doc.getTextWidth(texto) > maxW && fs > 6.2) {
            fs -= 0.25;
            doc.setFontSize(fs);
          }
          doc.text(doc.splitTextToSize(texto, maxW)[0], valX, y);
        } else {
          doc.text(texto, valX, y);
        }
        doc.setFontSize(9);
      };

      // ================= ENCABEZADO =================
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
      await new Promise((resolve) => {
        img.onload = () => {
          const maxH = 16;
          doc.addImage(img, "png", ML, 8, img.width * (maxH / img.height), maxH);
          resolve();
        };
        img.onerror = () => resolve();
      });

      doc.setFont(undefined, "bold").setFontSize(16);
      doc.setTextColor(...brandColor);
      doc.text(`ORDEN DE COMPRA DE MUESTRA # ${t(c.idMuestrasCompra)}`, pageW - ML, 15, {
        align: "right",
      });
      doc.setFont(undefined, "normal").setFontSize(9.5);
      doc.setTextColor(...labelColor);
      doc.text(`Fecha: ${t(c.fecha)}`, pageW - ML, 21, { align: "right" });
      doc.setTextColor(0);
      doc.setDrawColor(...brandColor).setLineWidth(0.6);
      doc.line(ML, 26, pageW - ML, 26);
      doc.setLineWidth(0.2).setDrawColor(0);

      // ================= CARD PROVEEDOR / PEDIDO =================
      const cardY = 29;
      const cardH = 36;
      doc.setDrawColor(...borderColor).setFillColor(...lightBg);
      doc.roundedRect(ML, cardY, contentW, cardH, 1.5, 1.5, "FD");
      doc.setDrawColor(0);

      const colA = ML + 3, colAv = ML + 26;
      const colB = pageW / 2 + 2, colBv = pageW / 2 + 26;
      const y0 = cardY + 6;
      const paso = 5.6;

      const anchoA = colB - colAv - 3;
      const anchoB = pageW - ML - 3 - colBv;

      drawLabel("Proveedor:", t(prov.nombre_comercial), colA, colAv, y0, anchoA);
      drawLabel("Contacto:", t(prov.contacto), colA, colAv, y0 + paso, anchoA);
      drawLabel("Teléfono:", t(prov.telefono), colA, colAv, y0 + paso * 2, anchoA);
      drawLabel("Correo:", t(prov.email), colA, colAv, y0 + paso * 3, anchoA);

      drawLabel("Línea:", t(c.subDepartamentos?.[0]?.name), colB, colBv, y0, anchoB);
      drawLabel("Modelo:", t(c.descripcion), colB, colBv, y0 + paso, anchoB);
      drawLabel("Color / Talla:",
        [t(c.colores?.[0]?.name), t(c.tallas?.[0]?.name)].filter(Boolean).join(" / "),
        colB, colBv, y0 + paso * 2, anchoB);
      drawLabel("Status:", t(c.status), colB, colBv, y0 + paso * 3, anchoB);
      drawLabel(
        "Cliente:",
        t(c.clientes?.[0]?.nombre_comercial),
        colA,
        colAv,
        y0 + paso * 4,
        anchoA
      );

      const seccion = (titulo, y) => {
        doc.setFillColor(...brandColor);
        doc.rect(ML, y, contentW, 6, "F");
        doc.setFont(undefined, "bold").setFontSize(9).setTextColor(255);
        doc.text(titulo, ML + 3, y + 4.2);
        doc.setTextColor(0).setFont(undefined, "normal");
        return y + 6;
      };

      const tablaBase = {
        margin: { left: ML, right: ML },
        theme: "grid",
        styles: { fontSize: 8, cellPadding: 1.8, lineColor: borderColor, lineWidth: 0.1 },
        headStyles: { fillColor: lightBg, textColor: 40, fontStyle: "bold", fontSize: 8 },
        alternateRowStyles: { fillColor: [251, 252, 253] },
        footStyles: { fillColor: [226, 233, 241], textColor: 20, fontStyle: "bold" },
      };

      // ================= LO QUE SE PIDE =================
      let y = seccion("MUESTRA SOLICITADA", cardY + cardH + 7);
      doc.autoTable({
        ...tablaBase,
        startY: y,
        columnStyles: {
          0: { cellWidth: 52 },
          1: { cellWidth: 34 },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
        },
        head: [["LÍNEA / MODELO", "TELA", "COLOR / TALLA", "PZAS", "P. UNITARIO", "IMPORTE"]],
        body: [
          [
            [t(c.subDepartamentos?.[0]?.name), t(c.descripcion)].filter(Boolean).join(" - ") || "—",
            t(c.tela) || "—",
            [t(c.colores?.[0]?.name), t(c.tallas?.[0]?.name)].filter(Boolean).join(" / ") || "—",
            String(cant),
            money(precio),
            money(subtotal),
          ],
        ],
        foot: [
          [
            { content: "SUBTOTAL", colSpan: 5, styles: { halign: "right" } },
            money(subtotal),
          ],
          [
            { content: `IVA (${c.iva === "Si" ? "16%" : "0%"})`, colSpan: 5, styles: { halign: "right" } },
            money(iva),
          ],
          [
            { content: "TOTAL", colSpan: 5, styles: { halign: "right" } },
            money(total),
          ],
        ],
      });

      // ================= MATERIAL ENTREGADO =================
      if (telasC.length) {
        y = seccion("TELA ENTREGADA AL PROVEEDOR", (doc.lastAutoTable?.finalY || y) + 7);
        doc.autoTable({
          ...tablaBase,
          startY: y,
          columnStyles: { 0: { cellWidth: 90 }, 2: { halign: "right" } },
          head: [["TELA", "COLOR", "CANTIDAD"]],
          body: telasC.map((x) => [
            t(x.telas?.[0]?.nombre) || "—",
            t(x.colores?.[0]?.name) || "—",
            `${n2(x.cantidad)} ${t(x.unidad) || "mts"}`,
          ]),
          foot: [[
            "TOTAL", "",
            `${n2(telasC.reduce((a, x) => a + Number(x.cantidad || 0), 0))} mts`,
          ]],
        });
      }

      if (habsC.length) {
        y = seccion("HABILITACIÓN ENTREGADA AL PROVEEDOR", (doc.lastAutoTable?.finalY || y) + 7);
        doc.autoTable({
          ...tablaBase,
          startY: y,
          columnStyles: { 0: { cellWidth: 130 }, 1: { halign: "right" } },
          head: [["HABILITACIÓN", "CANTIDAD"]],
          body: habsC.map((x) => [
            t(x.habilitacion?.[0]?.descripcion) || t(x.habilitacion?.[0]?.name) || "—",
            n2(x.cantidad),
          ]),
          foot: [[
            "TOTAL",
            n2(habsC.reduce((a, x) => a + Number(x.cantidad || 0), 0)),
          ]],
        });
      }

      // ================= OBSERVACIONES =================
      y = (doc.lastAutoTable?.finalY || y) + 7;
      if (t(c.observaciones)) {
        y = seccion("OBSERVACIONES", y);
        const txt = doc.splitTextToSize(t(c.observaciones), contentW - 6).slice(0, 4);
        const h = txt.length * 4.5 + 3;
        doc.setDrawColor(...borderColor).setFillColor(255);
        doc.rect(ML, y, contentW, h, "FD");
        doc.setFontSize(8.5).setTextColor(60);
        doc.text(txt, ML + 3, y + 5);
        doc.setTextColor(0);
        y += h + 10;
      }

      // ================= FIRMAS =================
      const yF = Math.min(Math.max(y + 12, 200), pageH - 40);
      doc.setDrawColor(...borderColor).setLineWidth(0.3);
      doc.line(ML + 10, yF, ML + 70, yF);
      doc.line(pageW - ML - 70, yF, pageW - ML - 10, yF);
      doc.setFontSize(8).setTextColor(...labelColor);
      doc.text("Autoriza", ML + 40, yF + 4, { align: "center" });
      doc.text("Recibe (Proveedor)", pageW - ML - 40, yF + 4, { align: "center" });
      doc.setTextColor(0);

      // ================= PIE =================
      const paginas = doc.internal.getNumberOfPages();
      for (let p = 1; p <= paginas; p++) {
        doc.setPage(p);
        doc.setDrawColor(...borderColor).setLineWidth(0.2);
        doc.line(ML, pageH - 12, pageW - ML, pageH - 12);
        doc.setFontSize(7.5).setTextColor(...labelColor);
        doc.text(
          `Orden de compra de muestra ${t(c.idMuestrasCompra)}  ·  ${t(prov.nombre_comercial)}`,
          ML,
          pageH - 8
        );
        doc.text(`Página ${p} de ${paginas}`, pageW - ML, pageH - 8, { align: "right" });
        doc.setTextColor(0);
      }

      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "No se pudo generar el PDF", "error");
    }
  };

  // ======================= IMÁGENES DE LA MUESTRA =======================
  // El archivo se sube a Cloudinary con /upmedia (devuelve secure_url + public_id)
  // y en MuestrasImagenes guardamos la referencia + su observación opcional.
  const cargaImagenes = async (idMuestra) => {
    try {
      const r = await axios.get(`${URL_MUESTRAS_IMAGENES}/muestra/${idMuestra}`, { headers });
      setImagenes(arr(r.data));
    } catch (e) {
      console.log(e);
      setImagenes([]);
    }
  };

  const abreImagenes = async (m) => {
    setMuestraImgs(m);
    setArchivosImg([]);
    setObsImg("");
    setImagenes([]);
    await cargaImagenes(m._id);
    setModalImgs(true);
  };

  const subeImagenes = async () => {
    if (!archivosImg.length)
      return Swal.fire("Falta la imagen", "Selecciona una o varias imágenes", "warning");
    setSubiendoImg(true);
    try {
      // De una en una: /upmedia arma el public_id con la hora, subir en paralelo
      // podría pisarse entre archivos del mismo lote.
      for (const archivo of archivosImg) {
        const fd = new FormData();
        fd.append("file", archivo);
        fd.append("articulo", muestraImgs._id);
        const up = await axios.post(URL_UPMEDIA, fd, { headers });
        const url = up.data?.secure_url || up.data?.url || "";
        if (!url) continue;
        await axios.post(
          URL_MUESTRAS_IMAGENES,
          {
            muestras: muestraImgs._id,
            url,
            publicId: up.data?.public_id || "",
            observaciones: obsImg || "",
            fecha: hoy,
            ...(user?.id ? { user: user.id } : {}),
          },
          { headers }
        );
      }
      setArchivosImg([]);
      setObsImg("");
      await cargaImagenes(muestraImgs._id);
      Swal.fire("Listo", "Imágenes subidas", "success");
    } catch (err) {
      console.log(err);
      Swal.fire("Error", `${err?.response?.data?.error || "No se pudieron subir"}`, "error");
    } finally {
      setSubiendoImg(false);
    }
  };

  // La observación se edita en la tarjeta y se guarda al salir del campo
  const guardaObsImagen = async (img, texto) => {
    if (String(img.observaciones || "") === String(texto || "")) return;
    try {
      await axios.patch(`${URL_MUESTRAS_IMAGENES}/${img._id}`, { observaciones: texto || "" }, { headers });
      setImagenes((prev) =>
        (prev || []).map((x) => (x._id === img._id ? { ...x, observaciones: texto || "" } : x))
      );
    } catch (err) {
      Swal.fire("Error", "No se pudo guardar la observación", "error");
    }
  };

  const quitaImagen = async (img) => {
    const res = await Swal.fire({
      title: "¿Eliminar la imagen?",
      text: "También se borra del servidor de imágenes.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });
    if (!res.isConfirmed) return;
    try {
      await axios.patch(`${URL_MUESTRAS_IMAGENES}/baja/${img._id}`, {}, { headers });
      setImagenes((prev) => (prev || []).filter((x) => x._id !== img._id));
    } catch (err) {
      Swal.fire("Error", "No se pudo eliminar", "error");
    }
  };

  // ======================= MATERIAL (tela / habilitación) =======================
  // (2026-08) Los mismos modales sirven para una MUESTRA propia o para una COMPRA
  // de muestra (material que se le entrega al proveedor, como en
  // ListadoOrdenesCorteExterno). matRef() resuelve a qué se liga la salida.
  const matRef = () =>
    compraMat
      ? {
          path: `/compra/${compraMat._id}`,
          body: { muestrasCompras: compraMat._id },
          titulo: `Compra #${compraMat.idMuestrasCompra} — ${
            compraMat.proveedores?.[0]?.nombre_comercial || "Proveedor"
          }`,
        }
      : {
          path: `/muestra/${muestraSel?._id}`,
          body: { muestras: muestraSel?._id },
          titulo: `Muestra ${muestraSel?.idMuestra || ""} — ${
            muestraSel ? nombreMuestra(muestraSel) : ""
          }`,
        };

  const recargaTela = async () => {
    const [rt, rr] = await Promise.all([
      axios.get(`${URL_MUESTRAS_TELAS}${matRef().path}`, { headers }),
      axios.get(`${URL_INVENTARIOS_TELAS}Existencia`, { headers }),
    ]);
    setTelasMuestra(arr(rt.data));
    setRollosTela(arr(rr.data));
  };

  const recargaHab = async () => {
    const [rh, rs] = await Promise.all([
      axios.get(`${URL_MUESTRAS_HABILITACION}${matRef().path}`, { headers }),
      axios.get(`${URL_INVENTARIOS_TELAS}ExistenciaHabilitacion`, { headers }),
    ]);
    setHabMuestra(arr(rh.data));
    setStockHabilitacion(arr(rs.data));
  };

  // ======================= TELA =======================
  // Escaneo del rollo: el QR trae el _id (24 chars), igual que en ListadoOrdenesCorte.
  const buscaRollo = (valor) => {
    setScanRollo(valor);
    if (String(valor).trim().length < 24) {
      setRolloSel("");
      setRolloInfo(null);
      return;
    }
    const id = String(valor).trim();
    const rollo = rollosTela.find((r) => r._id === id);
    if (!rollo) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El rollo no está disponible (ya fue cortado o apartado)",
        showConfirmButton: false,
        timer: 2000,
      });
      setScanRollo("");
      setRolloSel("");
      setRolloInfo(null);
      return;
    }
    if (telasMuestra.some((t) => t.inventariosTelas?.[0]?._id === id)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El rollo ya fue escaneado en esta muestra!",
        showConfirmButton: false,
        timer: 2000,
      });
      setScanRollo("");
      setRolloSel("");
      setRolloInfo(null);
      return;
    }
    setRolloSel(rollo._id);
    setRolloInfo(rollo);
    setCantTela(rollo.cantidad);
  };

  const abreTela = async (doc, esCompra = false) => {
    setMuestraSel(esCompra ? null : doc);
    setCompraMat(esCompra ? doc : null);
    setRolloSel("");
    setCantTela(0);
    setScanRollo("");
    setRolloInfo(null);
    setTelasMuestra([]);
    try {
      const path = esCompra ? `/compra/${doc._id}` : `/muestra/${doc._id}`;
      const [rt, rr] = await Promise.all([
        axios.get(`${URL_MUESTRAS_TELAS}${path}`, { headers }),
        axios.get(`${URL_INVENTARIOS_TELAS}Existencia`, { headers }),
      ]);
      setTelasMuestra(arr(rt.data));
      setRollosTela(arr(rr.data));
    } catch (e) {
      console.log(e);
    }
    setModalTela(true);
  };

  const agregaTela = async () => {
    if (!rolloSel)
      return Swal.fire("Falta el rollo", "Escanea el código del rollo", "warning");
    if (Number(cantTela) <= 0) return Swal.fire("Cantidad inválida", "Captura los metros", "warning");
    if (rolloInfo && Number(cantTela) > Number(rolloInfo.cantidad))
      return Swal.fire(
        "Cantidad mayor a la existencia",
        `El rollo solo tiene ${rolloInfo.cantidad}`,
        "warning"
      );
    const rollo = rollosTela.find((r) => r._id === rolloSel);
    try {
      await axios.post(
        URL_MUESTRAS_TELAS,
        {
          ...matRef().body,
          inventariosTelas: rolloSel,
          ...(rollo?.telas?.[0]?._id ? { telas: rollo.telas[0]._id } : {}),
          ...(rollo?.colores?.[0]?._id ? { colores: rollo.colores[0]._id } : {}),
          cantidad: Number(cantTela),
          unidad: "Metros",
          fecha: hoy,
        },
        { headers }
      );
      await recargaTela();
      setRolloSel("");
      setCantTela(0);
      setScanRollo("");
      setRolloInfo(null);
      Swal.fire(
        "Listo",
        compraMat ? "Tela entregada para la compra" : "Tela asignada a la muestra",
        "success"
      );
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo asignar"}`, "error");
    }
  };

  const quitaTela = async (t) => {
    const res = await Swal.fire({
      title: "¿Quitar esta tela?",
      text: "Se regresa la cantidad al rollo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
    });
    if (!res.isConfirmed) return;
    await axios.patch(`${URL_MUESTRAS_TELAS}/baja/${t._id}`, {}, { headers });
    await recargaTela();
  };

  // ======================= HABILITACIÓN =======================
  const abreHab = async (doc, esCompra = false) => {
    setMuestraSel(esCompra ? null : doc);
    setCompraMat(esCompra ? doc : null);
    setInvHabSel("");
    setCantHab(0);
    setHabMuestra([]);
    try {
      const path = esCompra ? `/compra/${doc._id}` : `/muestra/${doc._id}`;
      const [rh, rs] = await Promise.all([
        axios.get(`${URL_MUESTRAS_HABILITACION}${path}`, { headers }),
        axios.get(`${URL_INVENTARIOS_TELAS}ExistenciaHabilitacion`, { headers }),
      ]);
      setHabMuestra(arr(rh.data));
      setStockHabilitacion(arr(rs.data));
    } catch (e) {
      console.log(e);
    }
    setModalHab(true);
  };

  const agregaHab = async () => {
    if (!invHabSel) return Swal.fire("Falta la habilitación", "Selecciona la habilitación", "warning");
    if (Number(cantHab) <= 0) return Swal.fire("Cantidad inválida", "Captura la cantidad", "warning");
    const inv = stockHabilitacion.find((h) => h._id === invHabSel);
    try {
      await axios.post(
        URL_MUESTRAS_HABILITACION,
        {
          ...matRef().body,
          inventariosTelas: invHabSel,
          ...(inv?.habilitacion?.[0]?._id ? { habilitacion: inv.habilitacion[0]._id } : {}),
          cantidad: Number(cantHab),
          fecha: hoy,
        },
        { headers }
      );
      await recargaHab();
      setInvHabSel("");
      setCantHab(0);
      Swal.fire(
        "Listo",
        compraMat
          ? "Habilitación entregada para la compra"
          : "Habilitación entregada a la muestra",
        "success"
      );
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo entregar"}`, "error");
    }
  };

  const quitaHab = async (h) => {
    const res = await Swal.fire({
      title: "¿Quitar esta habilitación?",
      text: "Se regresa la cantidad al inventario.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
    });
    if (!res.isConfirmed) return;
    await axios.patch(`${URL_MUESTRAS_HABILITACION}/baja/${h._id}`, {}, { headers });
    await recargaHab();
  };

  // ======================= INVENTARIO: ENTRADAS / SALIDAS =======================
  // (2026-07) Registrar que el cliente REGRESÓ una salida: crea una Entrada
  // ligada a esa salida (movimientoSalida) para saber quién no ha devuelto.
  const registraRegreso = async (salida) => {
    const pendiente = Number(salida.pendiente ?? salida.cantidad ?? 0);
    const { value: cant } = await Swal.fire({
      title: "¿Cuántas regresó?",
      input: "number",
      inputValue: pendiente,
      inputAttributes: { min: 1, max: pendiente, step: 1 },
      text: `${salida.clientes?.[0]?.nombre_comercial || "Cliente"} — pendiente: ${pendiente}`,
      showCancelButton: true,
      confirmButtonText: "Registrar regreso",
      cancelButtonText: "Cancelar",
      inputValidator: (v) => {
        const n = Number(v);
        if (!n || n <= 0) return "Captura una cantidad mayor a 0";
        if (n > pendiente) return `Solo hay ${pendiente} por regresar`;
        return null;
      },
    });
    if (!cant) return;
    try {
      await axios.post(
        URL_MUESTRAS_MOVIMIENTOS,
        {
          muestras: salida.muestras?.[0]?._id || salida.muestras?.[0] || movMuestra?._id,
          tipo: "Entrada",
          movimientoSalida: salida._id,
          ...(salida.clientes?.[0]?._id ? { clientes: salida.clientes[0]._id } : {}),
          cantidad: Number(cant),
          fecha: hoy,
          observaciones: "Regreso de muestra",
          ...(user?.id ? { user: user.id } : {}),
        },
        { headers }
      );
      if (movMuestra) {
        const r = await axios.get(
          `${URL_MUESTRAS_MOVIMIENTOS}/muestra/${movMuestra._id}`,
          { headers }
        );
        setMovHistorial(arr(r.data));
      }
      cargaInventario();
      cargaPendientes();
      Swal.fire("Listo", "Regreso registrado", "success");
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo registrar"}`, "error");
    }
  };

  const abreMov = async (m, tipo) => {
    setMovMuestra(m);
    setMovTipo(tipo);
    setMovCantidad(1);
    setMovCliente("");
    setMovVendedor("");
    setMovObs("");
    try {
      const r = await axios.get(`${URL_MUESTRAS_MOVIMIENTOS}/muestra/${m._id}`, { headers });
      setMovHistorial(arr(r.data));
    } catch (e) {
      setMovHistorial([]);
    }
    setModalMov(true);
  };

  const guardaMov = async () => {
    if (Number(movCantidad) <= 0)
      return Swal.fire("Cantidad inválida", "Captura una cantidad mayor a 0", "warning");
    if (movTipo === "Salida" && !movCliente)
      return Swal.fire("Falta el cliente", "Selecciona a qué cliente sale la muestra", "warning");
    try {
      await axios.post(
        URL_MUESTRAS_MOVIMIENTOS,
        {
          muestras: movMuestra._id,
          tipo: movTipo,
          ...(movCliente ? { clientes: movCliente } : {}),
          ...(movVendedor ? { colaboradores: movVendedor } : {}),
          cantidad: Number(movCantidad),
          ...(movTipo === "Salida" ? { precio: Number(movPrecio) || 0 } : {}),
          fecha: hoy,
          observaciones: movObs || "NA",
          ...(user?.id ? { user: user.id } : {}),
        },
        { headers }
      );
      const r = await axios.get(`${URL_MUESTRAS_MOVIMIENTOS}/muestra/${movMuestra._id}`, { headers });
      setMovHistorial(arr(r.data));
      cargaInventario();
      cargaPendientes();
      setMovCantidad(1);
      setMovCliente("");
      setMovVendedor("");
      setMovPrecio(0);
      setMovObs("");
      Swal.fire("Listo", `${movTipo} registrada`, "success");
    } catch (err) {
      Swal.fire("Error", `${err?.response?.data || "No se pudo registrar"}`, "error");
    }
  };

  // ======================= FILTRADO =======================
  const muestrasFiltradas = useMemo(() => {
    let d = muestras;
    if (filtroStatus) d = d.filter((m) => m.status === filtroStatus);
    if (search) {
      const s = search.toLowerCase();
      d = d.filter(
        (m) =>
          String(m.idMuestra || "").includes(s) ||
          String(m.anio || "").includes(s) ||
          String(m.tela || "").toLowerCase().includes(s) ||
          nombreMuestra(m).toLowerCase().includes(s) ||
          (m.colores?.[0]?.name || "").toLowerCase().includes(s) ||
          clienteDeMuestra(m).toLowerCase().includes(s)
      );
    }
    return d.sort((a, b) => (a.idMuestra < b.idMuestra ? 1 : -1));
  }, [muestras, filtroStatus, search]);

  const inventarioFiltrado = useMemo(() => {
    let d = inventario;
    if (search) {
      const s = search.toLowerCase();
      d = d.filter(
        (m) =>
          String(m.idMuestra || "").includes(s) ||
          String(m.anio || "").includes(s) ||
          nombreMuestra(m).toLowerCase().includes(s) ||
          (m.colores?.[0]?.name || "").toLowerCase().includes(s)
      );
    }
    return d.sort((a, b) => (a.idMuestra < b.idMuestra ? 1 : -1));
  }, [inventario, search]);

  const totalExistencia = inventarioFiltrado.reduce(
    (s, m) => s + Number(m.existencia || 0),
    0
  );

  // ======================= RENDER =======================
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_muestras ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <Row className="mb-3">
                  <Col md={6}>
                    <Button size="sm" href="/Inicio" className="btn btn-danger">
                      Regresar
                    </Button>{" "}
                    <Button size="sm" color="success" onClick={abreNueva}>
                      + Nueva Muestra
                    </Button>{" "}
                    <Button size="sm" color="info" onClick={abreTraspaso}>
                      <i className="fas fa-exchange-alt"></i> Traspasar de Stock
                    </Button>{" "}
                    <Button size="sm" color="warning" onClick={abreCompra}>
                      <i className="fas fa-shopping-cart"></i> Comprar Muestra
                    </Button>
                  </Col>
                  <Col md={6} className="d-flex justify-content-end">
                    <Input
                      bsSize="sm"
                      style={{ maxWidth: 260 }}
                      placeholder="Buscar..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Col>
                </Row>

                <h3 align="center">Muestras</h3>

                {/* ---------- Pestañas ---------- */}
                <Row className="mb-3">
                  <Col md={12}>
                    <Button
                      color={tab === "muestras" ? "primary" : "secondary"}
                      outline={tab !== "muestras"}
                      onClick={() => setTab("muestras")}
                      className="me-2"
                    >
                      MUESTRAS
                    </Button>{" "}
                     <Button
                      color={tab === "compras" ? "warning" : "secondary"}
                      outline={tab !== "compras"}
                      onClick={() => {
                        setTab("compras");
                        cargaCompras();
                      }}
                    >
                      COMPRAS
                    </Button>
                    <Button
                      color={tab === "inventario" ? "primary" : "secondary"}
                      outline={tab !== "inventario"}
                      onClick={() => {
                        setTab("inventario");
                        cargaInventario();
                      }}
                      className="me-2"
                    >
                      INVENTARIO DE MUESTRAS
                    </Button>{" "}
                    <Button
                      color={tab === "pendientes" ? "danger" : "secondary"}
                      outline={tab !== "pendientes"}
                      onClick={() => {
                        setTab("pendientes");
                        cargaPendientes();
                      }}
                    >
                      <span style={{ whiteSpace: "nowrap" }}>
                        SIN REGRESAR{" "}
                        {pendientes.length ? (
                          <Badge
                            color="light"
                            className="text-danger"
                            style={{
                              display: "inline-block",
                              width: "auto",
                              verticalAlign: "middle",
                            }}
                          >
                            {pendientes.length}
                          </Badge>
                        ) : null}
                      </span>
                    </Button>{" "}
                   
                  </Col>
                </Row>

                {/* ================= TAB MUESTRAS ================= */}
                {tab === "muestras" ? (
                  <>
                    <Row className="mb-2">
                      <Col md={3}>
                        <Label>Status</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={filtroStatus}
                          onChange={(e) => setFiltroStatus(e.target.value)}
                        >
                          <option value="">Todas</option>
                          <option value="Sin Empezar">Sin Empezar</option>
                          <option value="Proceso">En Proceso</option>
                          <option value="Terminada">Terminadas</option>
                        </Input>
                      </Col>
                    </Row>

                    <div className="table-wrapper">
                    <Table size="sm" striped borderless className="mb-0 table-responsive-xl">
                      <thead>
                        <tr>
                          {[
                            ["#"],
                            ["Fecha"],
                            ["Año"],
                            ["Depto"],
                            ["Línea"],
                            ["Modelo"],
                            ["Tela"],
                            ["Color"],
                            ["Talla"],
                            ["Cliente"],
                            ["Vendedor"],
                            ["Pzas", "text-end"],
                            ["Status"],
                            ["Acciones", "text-center"],
                          ].map(([titulo, clase]) => (
                            <th
                              key={titulo}
                              className={clase}
                              style={{ position: "sticky", top: 0, zIndex: 2, background: "#fff" }}
                            >
                              {titulo}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {muestrasFiltradas.length ? (
                          muestrasFiltradas.map((m) => (
                            <tr key={m._id}>
                              <td>{m.idMuestra}</td>
                              <td>{m.fecha}</td>
                              <td>{m.anio || String(m.fecha || "").slice(0, 4)}</td>
                              <td>{m.departamentos?.[0]?.name || ""}</td>
                              <td>{m.subDepartamentos?.[0]?.name || ""}</td>
                              <td>{m.descripcion && m.descripcion !== "NA" ? m.descripcion : ""}</td>
                              <td>{m.tela && m.tela !== "NA" ? m.tela : ""}</td>
                              <td>{m.colores?.[0]?.name || ""}</td>
                              <td>{m.tallas?.[0]?.name || ""}</td>
                              <td>{clienteDeMuestra(m)}</td>
                              <td>
                                {`${m.colaboradores?.[0]?.nombre || ""} ${m.colaboradores?.[0]?.apellido || ""}`.trim()}
                              </td>
                              <td className="text-end">{m.cantidad}</td>
                              <td
                                title={
                                  m.status === "Terminada"
                                    ? [
                                        m.corto ? `Cortó: ${m.corto}` : "",
                                        m.confecciono ? `Confeccionó: ${m.confecciono}` : "",
                                        m.fechaHoraInicio ? `Inicio: ${m.fechaHoraInicio.replace("T", " ")}` : "",
                                        m.fechaHoraFin ? `Fin: ${m.fechaHoraFin.replace("T", " ")}` : "",
                                      ]
                                        .filter(Boolean)
                                        .join(" · ")
                                    : ""
                                }
                              >
                                <Badge
                                  color={
                                    m.status === "Terminada"
                                      ? "success"
                                      : m.status === "Proceso"
                                      ? "warning"
                                      : "secondary"
                                  }
                                >
                                  {m.status}
                                </Badge>
                              </td>
                              <td className="text-center" style={{ minWidth: 260 }}>
                                <Button
                                  size="sm"
                                  color="info"
                                  className="me-1"
                                  title="Asignar tela"
                                  onClick={() => abreTela(m)}
                                >
                                  <i className="fas fa-tape"></i>
                                </Button>
                                <Button
                                  size="sm"
                                  color="warning"
                                  className="me-1"
                                  title="Salida de habilitación"
                                  onClick={() => abreHab(m)}
                                >
                                  <i className="fas fa-tag"></i>
                                </Button>
                                {/* (2026-08) Galería de imágenes de la muestra */}
                                <Button
                                  size="sm"
                                  color="dark"
                                  className="me-1"
                                  title="Imágenes de la muestra"
                                  onClick={() => abreImagenes(m)}
                                >
                                  <i className="fas fa-images"></i>
                                </Button>
                                {/* (2026-08) Formato Consumo y Habilitación */}
                                {m.status === "Terminada" ? (
                                  <Button
                                    size="sm"
                                    color="danger"
                                    className="me-1"
                                    title="PDF Consumo y Habilitación"
                                    onClick={() => PDFConsumo(m)}
                                  >
                                    <i className="far fa-file-pdf"></i>
                                  </Button>
                                ) : null}
                                {/* (2026-10) corregir Cortó / Confeccionó / horas */}
                                {m.status === "Terminada" ? (
                                  <Button
                                    size="sm"
                                    color="success"
                                    className="me-1"
                                    title="Editar datos de terminación (cortó, confeccionó, horas)"
                                    onClick={() => terminaMuestra(m, true)}
                                  >
                                    <i className="fas fa-user-edit"></i>
                                  </Button>
                                ) : null}
                                {m.status === "Sin Empezar" ? (
                                  <Button
                                    size="sm"
                                    color="secondary"
                                    className="me-1"
                                    title="Marcar En Proceso"
                                    onClick={() => cambiaStatus(m, "Proceso")}
                                  >
                                    <i className="fas fa-play"></i>
                                  </Button>
                                ) : null}
                                {m.status === "Proceso" ? (
                                  <Button
                                    size="sm"
                                    color="light"
                                    className="me-1"
                                    title="Regresar a Sin Empezar"
                                    onClick={() => cambiaStatus(m, "Sin Empezar")}
                                  >
                                    <i className="fas fa-undo"></i>
                                  </Button>
                                ) : null}
                                {m.status !== "Terminada" ? (
                                  <Button
                                    size="sm"
                                    color="success"
                                    className="me-1"
                                    title="Terminar muestra"
                                    onClick={() => terminaMuestra(m)}
                                  >
                                    <i className="fas fa-check"></i>
                                  </Button>
                                ) : null}
                                <Button
                                  size="sm"
                                  color="primary"
                                  className="me-1"
                                  title="Editar"
                                  onClick={() => abreEdita(m)}
                                >
                                  <i className="fas fa-edit"></i>
                                </Button>
                                <Button
                                  size="sm"
                                  color="danger"
                                  title="Dar de baja"
                                  onClick={() => bajaMuestra(m)}
                                >
                                  <i className="fas fa-times"></i>
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="14" className="text-center text-muted">
                              No hay muestras para mostrar
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    </div>
                  </>
                ) : tab === "inventario" ? (
                  /* ================= TAB INVENTARIO ================= */
                  <>
                    <h5 className="text-success">
                      Existencia total: {new Intl.NumberFormat("en-US").format(totalExistencia)} pzas
                    </h5>
                    <Table size="sm" striped borderless className="table-responsive-xl">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Año</th>
                          <th>Línea / Modelo</th>
                          <th>Color</th>
                          <th>Talla</th>
                          <th className="text-end">Entradas</th>
                          <th className="text-end">Salidas</th>
                          <th className="text-end">Existencia</th>
                          <th className="text-center">Movimientos</th>
                        </tr>
                      </thead>
                      <tbody>
                        {inventarioFiltrado.length ? (
                          inventarioFiltrado.map((m) => (
                            <tr key={m._id}>
                              <td>{m.idMuestra}</td>
                              <td>{m.anio || String(m.fecha || "").slice(0, 4)}</td>
                              <td>{nombreMuestra(m)}</td>
                              <td>{m.colores?.[0]?.name || ""}</td>
                              <td>{m.tallas?.[0]?.name || ""}</td>
                              <td className="text-end">{m.entradas}</td>
                              <td className="text-end">{m.salidas}</td>
                              <td className="text-end">
                                <b>{m.existencia}</b>
                              </td>
                              <td className="text-center" style={{ minWidth: 150 }}>
                                {/* La Entrada ya no se captura suelta: se registra
                                    como REGRESO de una salida, desde este mismo modal. */}
                                <Button
                                  size="sm"
                                  color="danger"
                                  onClick={() => abreMov(m, "Salida")}
                                >
                                  <i className="fas fa-truck"></i> Salidas
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center text-muted">
                              Aún no hay muestras terminadas en inventario
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </>
                ) : tab === "pendientes" ? (
                  /* ============ TAB SIN REGRESAR (quién tiene muestras) ============ */
                  <>
                    <Row className="mb-2">
                      <Col md={4}>
                        <Label className="mb-0">
                          <small>Vendedor</small>
                        </Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={filtroVendedor}
                          onChange={(e) => setFiltroVendedor(e.target.value)}
                        >
                          <option value="">Todos los vendedores</option>
                          {vendedoresPendientes.map((v) => (
                            <option value={v.id} key={v.id}>
                              {v.nombre}
                            </option>
                          ))}
                        </Input>
                      </Col>
                    </Row>
                    <h5 className="text-danger">
                      Muestras sin regresar:{" "}
                      {new Intl.NumberFormat("en-US").format(
                        pendientesFiltrados.reduce((s, p) => s + Number(p.pendiente || 0), 0)
                      )}{" "}
                      pzas en {pendientesFiltrados.length} salida(s)
                    </h5>
                    <Table size="sm" striped borderless className="table-responsive-xl">
                      <thead>
                        <tr>
                          <th>Cliente</th>
                          <th>Vendedor</th>
                          <th>Muestra</th>
                          <th>Color</th>
                          <th>Talla</th>
                          <th>Fecha Salida</th>
                          <th>Días</th>
                          <th className="text-end">Salió</th>
                          <th className="text-end">Regresó</th>
                          <th className="text-end">Pagó</th>
                          <th className="text-end">Pendiente</th>
                          <th className="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendientesFiltrados.length ? (
                          pendientesFiltrados.map((p) => {
                            const dias = moment().diff(moment(p.fecha, "YYYY-MM-DD"), "days");
                            return (
                              <tr key={p._id}>
                                <td>
                                  <b>{p.clientes?.[0]?.nombre_comercial || "Sin cliente"}</b>
                                </td>
                                <td>{nombreVendedor(p)}</td>
                                <td>{nombreMuestra(p.muestras?.[0] || {})}</td>
                                <td>{p.muestras?.[0]?.colores?.[0]?.name || ""}</td>
                                <td>{p.muestras?.[0]?.tallas?.[0]?.name || ""}</td>
                                <td>{p.fecha}</td>
                                <td>
                                  <Badge color={dias > 30 ? "danger" : dias > 15 ? "warning" : "secondary"}>
                                    {dias}
                                  </Badge>
                                </td>
                                <td className="text-end">{p.cantidad}</td>
                                <td className="text-end">{p.devuelto}</td>
                                <td className="text-end">{p.pagadas || 0}</td>
                                <td className="text-end">
                                  <b className="text-danger">{p.pendiente}</b>
                                </td>
                                <td className="text-center">
                                  <Button
                                    size="sm"
                                    color="success"
                                    className="me-1"
                                    onClick={() => registraRegreso(p)}
                                  >
                                    <i className="fas fa-undo"></i> Regresó
                                  </Button>
                                  <Button
                                    size="sm"
                                    color="primary"
                                    title="El cliente se quedó la muestra y la pagó"
                                    onClick={() => registraPago(p)}
                                  >
                                    <i className="fas fa-dollar-sign"></i> Pagó
                                  </Button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="12" className="text-center text-muted">
                              Todas las muestras han sido regresadas
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </>
                ) : (
                  /* ============ TAB COMPRAS (OC + recepción que genera CxP) ============ */
                  <>
                    <Table size="sm" striped borderless className="table-responsive-xl">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Fecha</th>
                          <th>Proveedor</th>
                          <th>Cliente</th>
                          <th>Línea / Modelo</th>
                          <th>Tela</th>
                          <th>Color</th>
                          <th>Talla</th>
                          <th className="text-end">Pzas</th>
                          <th className="text-end">Precio</th>
                          <th className="text-end">Total</th>
                          <th>IVA</th>
                          <th>Status</th>
                          <th className="text-center"> Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {compras.length ? (
                          compras
                            .sort((a, b) =>
                              a.idMuestrasCompra < b.idMuestrasCompra ? 1 : -1
                            )
                            .map((c) => {
                              const sub =
                                Number(c.cantidad || 0) * Number(c.precio || 0);
                              const tot = c.iva === "Si" ? sub * 1.16 : sub;
                              return (
                                <tr key={c._id}>
                                  <td>{c.idMuestrasCompra}</td>
                                  <td>{c.fecha}</td>
                                  <td>{c.proveedores?.[0]?.nombre_comercial || ""}</td>
                                  <td>{c.clientes?.[0]?.nombre_comercial || ""}</td>
                                  <td>
                                    {c.subDepartamentos?.[0]?.name || ""}
                                    {c.descripcion && c.descripcion !== "NA"
                                      ? ` - ${c.descripcion}`
                                      : ""}
                                  </td>
                                  <td>{c.tela && c.tela !== "NA" ? c.tela : ""}</td>
                                  <td>{c.colores?.[0]?.name || ""}</td>
                                  <td>{c.tallas?.[0]?.name || ""}</td>
                                  <td className="text-end">{c.cantidad}</td>
                                  <td className="text-end">
                                    {new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                    }).format(c.precio || 0)}
                                  </td>
                                  <td className="text-end">
                                    {new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                    }).format(tot)}
                                  </td>
                                  <td>{c.iva}</td>
                                  <td>
                                    <Badge
                                      color={
                                        c.status === "Recibida"
                                          ? "success"
                                          : c.status === "Cancelada"
                                          ? "secondary"
                                          : "warning"
                                      }
                                      title={
                                        c.status === "Cancelada"
                                          ? `${c.fechaCancelacion || ""} · ${c.motivoCancelacion || ""}`
                                          : undefined
                                      }
                                    >
                                      {c.status}
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    {/* (2026-08) Material que le entregamos al
                                        proveedor, igual que en corte externo */}
                                    <Button
                                      size="sm"
                                      color="danger"
                                      className="me-1"
                                      title="PDF de la orden (para el proveedor)"
                                      onClick={() => PDFCompra(c)}
                                    >
                                      <i className="far fa-file-pdf"></i>
                                    </Button>
                                    {/* (2026-08) Editar solo mientras esté Pendiente */}
                                    {c.status !== "Recibida" && c.status !== "Cancelada" ? (
                                      <Button
                                        size="sm"
                                        color="primary"
                                        className="me-1"
                                        title="Editar orden"
                                        onClick={() => abreEditaCompra(c)}
                                      >
                                        <i className="fas fa-edit"></i>
                                      </Button>
                                    ) : null}
                                    {c.status !== "Cancelada" ? (
                                      <>
                                        <Button
                                          size="sm"
                                          color="info"
                                          className="me-1"
                                          onClick={() => abreTela(c, true)}
                                          title="Salida de tela (escanear rollo)"
                                        >
                                          <i className="fas fa-tape"></i>
                                        </Button>
                                        <Button
                                          size="sm"
                                          color="secondary"
                                          className="me-1"
                                          onClick={() => abreHab(c, true)}
                                          title="Salida de habilitación"
                                        >
                                          <i className="fas fa-tag"></i>
                                        </Button>
                                        {/* (2026-10) cancelar la compra */}
                                        <Button
                                          size="sm"
                                          color="dark"
                                          className="me-1"
                                          title="Cancelar compra"
                                          onClick={() => cancelaCompra(c)}
                                        >
                                          <i className="fas fa-ban"></i>
                                        </Button>
                                      </>
                                    ) : null}
                                    {c.status === "Cancelada" ? null : c.status !== "Recibida" ? (
                                      <Button
                                        size="sm"
                                        color="success"
                                        onClick={() => recibeCompra(c)}
                                      >
                                        <i className="fas fa-box-open"></i>
                                      </Button>
                                    ) : (
                                      /* (2026-08) Reimprimir el ticket de la recepción */
                                      <Button
                                        size="sm"
                                        color="secondary"
                                        title="Ticket de recepción"
                                        onClick={() => TicketRecepcion(c)}
                                      >
                                        <i className="fas fa-receipt"></i>
                                      </Button>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colSpan="14" className="text-center text-muted">
                              Sin órdenes de compra de muestras
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    <small className="text-muted">
                      Al recibir, la muestra entra al inventario de muestras y se genera
                      la NotaCxP del proveedor (visible en el módulo CxP).
                    </small>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* ============ MODAL TRASPASO DE STOCK -> MUESTRAS (T3) ============ */}
          <Modal size="lg" isOpen={modalTraspaso} toggle={() => setModalTraspaso(!modalTraspaso)}>
            <ModalHeader toggle={() => setModalTraspaso(!modalTraspaso)}>
              Traspasar de Inventario de Stock a Muestras
            </ModalHeader>
            <ModalBody>
              <Row className="mb-2">
                <Col md={6}>
                  <Label>Artículo</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={traspArticulo}
                    onChange={(e) => {
                      setTraspArticulo(e.target.value);
                      cargaDetalleTraspaso(e.target.value, traspArea);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {articulos
                      .sort((a, b) => ((a.codigo || "") > (b.codigo || "") ? 1 : -1))
                      .map((a) => (
                        <option value={a._id} key={a._id}>
                          {a.codigo} {a.descripcion || ""}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={6}>
                  <Label>Almacén / Área</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={traspArea}
                    onChange={(e) => {
                      setTraspArea(e.target.value);
                      cargaDetalleTraspaso(traspArticulo, e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {areas
                      .sort((a, b) => ((a.name || "") > (b.name || "") ? 1 : -1))
                      .map((a) => (
                        <option value={a._id} key={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>
              </Row>
              <Row className="mb-3 align-items-end">
                <Col md={7}>
                  <Label>Color / Talla con existencia</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={traspCombo}
                    onChange={(e) => setTraspCombo(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {traspDetalle.map((d) => (
                      <option value={d._id} key={d._id}>
                        {d.colores?.[0]?.name || "Color"} / {d.tallas?.[0]?.name || "Talla"} —{" "}
                        {d.cantidad} pzas
                      </option>
                    ))}
                  </Input>
                  {traspArticulo && traspArea && !traspDetalle.length ? (
                    <small className="text-danger">
                      Ese artículo no tiene existencia en esa área.
                    </small>
                  ) : null}
                </Col>
                <Col md={3}>
                  <Label>Piezas</Label>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={traspCantidad}
                    onChange={(e) => setTraspCantidad(e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Button color="success" size="sm" onClick={guardaTraspaso}>
                    Traspasar
                  </Button>
                </Col>
              </Row>
              <small className="text-muted">
                Se descuenta del inventario de stock y entra como muestra terminada al
                inventario de muestras.
              </small>
            </ModalBody>
          </Modal>

          {/* ============ MODAL COMPRA DE MUESTRA (T4) ============ */}
          <Modal size="lg" isOpen={modalCompra} toggle={() => setModalCompra(!modalCompra)}>
            <ModalHeader toggle={() => setModalCompra(!modalCompra)}>
              {idEditCompra
                ? "Editar Orden de Compra de Muestra"
                : "Nueva Orden de Compra de Muestra"}
            </ModalHeader>
            <ModalBody>
              <Row className="mb-2">
                <Col md={6}>
                  <Label>Proveedor *</Label>
                  <Buscador
                    value={cpProveedor}
                    onChange={setCpProveedor}
                    opciones={proveedores}
                    etiqueta={(o) => o.nombre_comercial}
                  />
                </Col>
                <Col md={6}>
                  <Label>Cliente</Label>
                  <Buscador
                    value={cpCliente}
                    onChange={setCpCliente}
                    opciones={clientes}
                    etiqueta={(o) => o.nombre_comercial}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={6}>
                  <Label>Línea *</Label>
                  <Buscador
                    value={cpLinea}
                    onChange={setCpLinea}
                    opciones={lineas}
                    etiqueta={(o) => o.name}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>
                  <Label>Color</Label>
                  <Buscador
                    value={cpColor}
                    onChange={setCpColor}
                    opciones={colores}
                    etiqueta={(o) => o.name}
                  />
                </Col>
                <Col md={4}>
                  <Label>Talla</Label>
                  <Buscador
                    value={cpTalla}
                    onChange={setCpTalla}
                    opciones={tallas}
                    etiqueta={nombreTalla}
                  />
                </Col>
                <Col md={4}>
                  <Label>Modelo / Descripción</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={cpDescripcion}
                    onChange={(e) => setCpDescripcion(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={12}>
                  <Label>Tela</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={cpTela}
                    placeholder="Tela que debe usar el proveedor (se escribe)"
                    onChange={(e) => setCpTela(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={3}>
                  <Label>Piezas *</Label>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={cpCantidad}
                    onChange={(e) => setCpCantidad(e.target.value)}
                  />
                </Col>
                <Col md={3}>
                  <Label>Precio Unitario</Label>
                  <Input
                    bsSize="sm"
                    type="number"
                    step="any"
                    value={cpPrecio}
                    onChange={(e) => setCpPrecio(e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Label>IVA</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={cpIva}
                    onChange={(e) => setCpIva(e.target.value)}
                  >
                    <option value="No">No</option>
                    <option value="Si">Sí (16%)</option>
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Total</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    disabled
                    value={new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(
                      Number(cpCantidad || 0) *
                        Number(cpPrecio || 0) *
                        (cpIva === "Si" ? 1.16 : 1)
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Label>Observaciones</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={cpObs}
                    onChange={(e) => setCpObs(e.target.value)}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={guardaCompra}>
                {idEditCompra ? "Guardar Cambios" : "Crear Orden de Compra"}
              </Button>
            </ModalFooter>
          </Modal>

          {/* ================= MODAL NUEVA / EDITAR MUESTRA ================= */}
          <Modal size="lg" isOpen={modalMuestra} toggle={() => setModalMuestra(!modalMuestra)}>
            <ModalHeader toggle={() => setModalMuestra(!modalMuestra)}>
              {idEdit ? "Editar Muestra" : "Nueva Muestra"}
            </ModalHeader>
            <ModalBody>
              <Row className="mb-2">
                <Col md={3}>
                  <Label>Fecha</Label>
                  <Input
                    // bsSize="sm"
                    type="date"
                    value={fecha}
                    onChange={(e) => {
                      setFecha(e.target.value);
                      // el año sigue a la fecha mientras no se capture a mano
                      if (e.target.value) setAnio(String(e.target.value).slice(0, 4));
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label>Año</Label>
                  <Input
                    // bsSize="sm"
                    type="number"
                    value={anio}
                    onChange={(e) => setAnio(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Línea *</Label>
                  <Buscador
                    value={linea}
                    onChange={setLinea}
                    opciones={lineas}
                    etiqueta={(o) => o.name}
                  />
                </Col>
                <Col md={3}>
                  <Label>Piezas</Label>
                  <Input
                    // bsSize="sm"
                    type="number"
                    value={cantidad}
                    onChange={(e) => setCantidad(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>
                  <Label>Color</Label>
                  <Buscador
                    value={color}
                    onChange={setColor}
                    opciones={colores}
                    etiqueta={(o) => o.name}
                  />
                </Col>
                <Col md={4}>
                  <Label>Talla</Label>
                  <Buscador
                    value={talla}
                    onChange={setTalla}
                    opciones={tallas}
                    etiqueta={nombreTalla}
                  />
                </Col>
                <Col md={4}>
                  {/* (2026-10) para un cliente o para un prospecto del CRM */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 4 }}>
                    <Label style={{ marginBottom: 0 }}>
                      {destinoMuestra === "prospecto" ? "Prospecto (opcional)" : "Cliente (opcional)"}
                    </Label>
                    <div>
                      {[
                        ["cliente", "Cliente"],
                        ["prospecto", "Prospecto"],
                      ].map(([v, l]) => (
                        <Button
                          key={v}
                          size="sm"
                          color={destinoMuestra === v ? "info" : "secondary"}
                          style={{ padding: "0 6px", fontSize: 11, marginLeft: 2 }}
                          onClick={() => setDestinoMuestra(v)}
                        >
                          {l}
                        </Button>
                      ))}
                    </div>
                  </div>
                  {destinoMuestra === "prospecto" ? (
                    <Buscador
                      value={prospectoMuestra}
                      onChange={setProspectoMuestra}
                      opciones={prospectos}
                      etiqueta={nombreProspecto}
                    />
                  ) : (
                    <Buscador
                      value={cliente}
                      onChange={setCliente}
                      opciones={clientes}
                      etiqueta={(o) => o.nombre_comercial}
                    />
                  )}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>
                  <Label>Modelo / Descripción</Label>
                  <Input
                    // bsSize="sm"
                    type="text"
                    value={descripcion}
                    placeholder="Ej. Blusa manga larga cuello camisero"
                    onChange={(e) => setDescripcion(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Departamento</Label>
                  <Buscador
                    value={departamento}
                    onChange={setDepartamento}
                    opciones={departamentos}
                    etiqueta={(o) => o.name}
                  />
                </Col>
                <Col md={4}>
                  <Label>Tela</Label>
                  <Input
                    // bsSize="sm"
                    type="text"
                    value={telaMuestra}
                    placeholder="Se escribe (no viene del catálogo)"
                    onChange={(e) => setTelaMuestra(e.target.value)}
                  />
                </Col>
                </Row>
                <Row className="mb-2">
                <Col md={6}>
                  <Label>Vendedor</Label>
                  <Buscador
                    value={vendedorMuestra}
                    onChange={setVendedorMuestra}
                    opciones={colaboradores}
                    etiqueta={(o) => `${o.nombre || ""} ${o.apellido || ""}`.trim()}
                  />
                </Col>
                <Col md={6}>
                  <Label>Observaciones (Marca y Monarch)</Label>
                  <Input
                    // bsSize="sm"
                    type="text"
                    value={observaciones}
                    onChange={(e) => setObservaciones(e.target.value)}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={guardaMuestra}>
                Guardar
              </Button>
            </ModalFooter>
          </Modal>

          {/* ================= MODAL TELA ================= */}
          {/* ============ TERMINAR MUESTRA (datos de cierre) ============ */}
          <Modal
            size="lg"
            isOpen={modalTerminar}
            toggle={() => setModalTerminar(!modalTerminar)}
          >
            <ModalHeader toggle={() => setModalTerminar(!modalTerminar)}>
              {editandoTerminar ? "Editar Muestra Terminada" : "Terminar Muestra"} {muestraTerminar?.idMuestra}{" "}
              {muestraTerminar ? `— ${nombreMuestra(muestraTerminar)}` : ""}
            </ModalHeader>
            <ModalBody>
              {editandoTerminar ? (
                <p className="text-muted">
                  Sólo se corrigen quién cortó, quién confeccionó y las horas; el
                  inventario no cambia.
                </p>
              ) : (
                <p className="text-muted">
                  Entrarán <b>{muestraTerminar?.cantidad || 0}</b> pza(s) al inventario
                  de muestras.
                </p>
              )}
              <Row className="mb-2">
                <Col md={6}>
                  <Label>Cortó</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={corto}
                    placeholder="Nombre de quien cortó"
                    onChange={(e) => setCorto(e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <Label>Confeccionó</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={confecciono}
                    placeholder="Nombre de quien confeccionó"
                    onChange={(e) => setConfecciono(e.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Label>Fecha y Hora Inicio</Label>
                  <Input
                    bsSize="sm"
                    type="datetime-local"
                    value={fhInicio}
                    onChange={(e) => setFhInicio(e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <Label>Fecha y Hora Fin</Label>
                  <Input
                    bsSize="sm"
                    type="datetime-local"
                    value={fhFin}
                    onChange={(e) => setFhFin(e.target.value)}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={confirmaTerminar}>
                {editandoTerminar ? "Guardar cambios" : "Terminar muestra"}
              </Button>
            </ModalFooter>
          </Modal>

          {/* ============ IMÁGENES DE LA MUESTRA ============ */}
          <Modal
            size="xl"
            isOpen={modalImgs}
            toggle={() => setModalImgs(!modalImgs)}
          >
            <ModalHeader toggle={() => setModalImgs(!modalImgs)}>
              Imágenes — Muestra {muestraImgs?.idMuestra}{" "}
              {muestraImgs ? `— ${nombreMuestra(muestraImgs)}` : ""}
            </ModalHeader>
            <ModalBody>
              <Row className="mb-3 align-items-end">
                <Col md={5}>
                  <Label>Imagen(es)</Label>
                  <Input
                    bsSize="sm"
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => setArchivosImg(Array.from(e.target.files || []))}
                  />
                  <small className="text-muted">
                    Puedes seleccionar varias a la vez.
                  </small>
                </Col>
                <Col md={5}>
                  <Label>Observación (opcional)</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={obsImg}
                    placeholder="Se aplica a las imágenes de esta subida"
                    onChange={(e) => setObsImg(e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Button
                    size="sm"
                    color="success"
                    className="w-100"
                    disabled={subiendoImg || !archivosImg.length}
                    onClick={subeImagenes}
                  >
                    {subiendoImg ? "Subiendo..." : "Subir"}
                  </Button>
                </Col>
              </Row>

              <hr />

              {imagenes.length ? (
                <Row>
                  {imagenes.map((img) => (
                    <Col md={3} className="mb-3" key={img._id}>
                      <div
                        style={{
                          border: "1px solid #dee2e6",
                          borderRadius: 8,
                          padding: 8,
                          height: "100%",
                        }}
                      >
                        <a href={img.url} target="_blank" rel="noopener noreferrer">
                          <img
                            src={img.url}
                            alt="Muestra"
                            style={{
                              width: "100%",
                              height: 170,
                              objectFit: "cover",
                              borderRadius: 6,
                              cursor: "zoom-in",
                            }}
                          />
                        </a>
                        <Input
                          bsSize="sm"
                          type="text"
                          className="mt-2"
                          placeholder="Observación (opcional)"
                          defaultValue={img.observaciones || ""}
                          onBlur={(e) => guardaObsImagen(img, e.target.value)}
                        />
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <small className="text-muted">{img.fecha || ""}</small>
                          <Button
                            size="sm"
                            color="danger"
                            title="Eliminar imagen"
                            onClick={() => quitaImagen(img)}
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              ) : (
                <p className="text-center text-muted mb-0">
                  Esta muestra todavía no tiene imágenes.
                </p>
              )}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalTela} toggle={() => setModalTela(!modalTela)}>
            <ModalHeader toggle={() => setModalTela(!modalTela)}>
              Tela — {matRef().titulo}
            </ModalHeader>
            <ModalBody>
              {/* Escaneo del rollo (igual que en ListadoOrdenesCorte) */}
              <Row className="mb-2 align-items-end">
                <Col md={7}>
                  <Label>
                    <i className="fas fa-barcode"></i> Escanea el rollo
                  </Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    autoFocus
                    placeholder="Escanea el código del rollo..."
                    value={scanRollo}
                    onChange={(e) => buscaRollo(e.target.value)}
                  />
                </Col>
                <Col md={3}>
                  <Label>Metros</Label>
                  <Input
                    bsSize="sm"
                    type="number"
                    step="any"
                    value={cantTela}
                    // onChange={(e) => setCantTela(e.target.value)}
                    disabled
                  />
                </Col>
                <Col md={2}>
                  <Button color="success" size="sm" onClick={agregaTela}>
                    Asignar
                  </Button>
                </Col>
              </Row>

              {/* Rollo escaneado */}
              {rolloInfo ? (
                <Row className="mb-3">
                  <Col md={12}>
                    <div
                      style={{
                        border: "1px solid #badbcc",
                        background: "#d1e7dd",
                        borderRadius: 6,
                        padding: "8px 12px",
                      }}
                    >
                      <b>Rollo:</b> {rolloInfo.telas?.[0]?.nombre || "Tela"} /{" "}
                      {rolloInfo.colores?.[0]?.name || "Color"} — disponibles:{" "}
                      <b>{rolloInfo.cantidad}</b>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row className="mb-3">
                  <Col md={12}>
                    <small className="text-muted">
                      Escanea el código del rollo para asignarlo a la muestra.
                    </small>
                  </Col>
                </Row>
              )}

              {/* (2026-08) Comprobante de la tela entregada */}
              <div className="d-flex justify-content-end mb-2">
                <Button
                  size="sm"
                  color="danger"
                  disabled={!telasMuestra.length}
                  title="PDF de la tela entregada"
                  onClick={PDFTelaEntregada}
                >
                  <i className="far fa-file-pdf"></i> PDF tela entregada
                </Button>
              </div>

              <Table size="sm" striped>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Tela</th>
                    <th>Color</th>
                    <th className="text-end">Cantidad</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {telasMuestra.length ? (
                    telasMuestra.map((t) => (
                      <tr key={t._id}>
                        <td>{t.fecha}</td>
                        <td>{t.telas?.[0]?.nombre || ""}</td>
                        <td>{t.colores?.[0]?.name || ""}</td>
                        <td className="text-end">
                          {t.cantidad} {t.unidad}
                        </td>
                        <td className="text-center">
                          <Button size="sm" color="danger" onClick={() => quitaTela(t)}>
                            <i className="fas fa-times"></i>
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted">
                        Sin tela asignada
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>

          {/* ================= MODAL HABILITACIÓN ================= */}
          <Modal size="lg" isOpen={modalHab} toggle={() => setModalHab(!modalHab)}>
            <ModalHeader toggle={() => setModalHab(!modalHab)}>
              Habilitación — {matRef().titulo}
            </ModalHeader>
            <ModalBody>
              <Row className="mb-3 align-items-end">
                <Col md={7}>
                  <Label>Habilitación disponible</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={invHabSel}
                    onChange={(e) => setInvHabSel(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {stockHabilitacion.map((h) => (
                      <option value={h._id} key={h._id}>
                        {h.habilitacion?.[0]?.nombre || "Habilitación"}{" "}
                        {h.habilitacion?.[0]?.descripcion || ""} — {h.cantidad} disponibles
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Cantidad</Label>
                  <Input
                    bsSize="sm"
                    type="number"
                    step="any"
                    value={cantHab}
                    onChange={(e) => setCantHab(e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Button color="success" size="sm" onClick={agregaHab}>
                    Entregar
                  </Button>
                </Col>
              </Row>

              <Table size="sm" striped>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Habilitación</th>
                    <th className="text-end">Cantidad</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {habMuestra.length ? (
                    habMuestra.map((h) => (
                      <tr key={h._id}>
                        <td>{h.fecha}</td>
                        <td>
                          {h.habilitacion?.[0]?.nombre || ""}{" "}
                          {h.habilitacion?.[0]?.descripcion || ""}
                        </td>
                        <td className="text-end">{h.cantidad}</td>
                        <td className="text-center">
                          <Button size="sm" color="danger" onClick={() => quitaHab(h)}>
                            <i className="fas fa-times"></i>
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted">
                        Sin habilitación entregada
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>

          {/* ================= MODAL MOVIMIENTO INVENTARIO ================= */}
          <Modal size="lg" isOpen={modalMov} toggle={() => setModalMov(!modalMov)}>
            <ModalHeader toggle={() => setModalMov(!modalMov)}>
              {movTipo} — Muestra {movMuestra?.idMuestra}{" "}
              {movMuestra ? `(${nombreMuestra(movMuestra)})` : ""}
            </ModalHeader>
            <ModalBody>
              {/* El tipo (Entrada/Salida) lo define el botón con el que se abrió
                  el modal, por eso aquí ya no se selecciona. */}
              <Row className="mb-3 align-items-end">
                <Col md={2}>
                  <Label>Cantidad</Label>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={movCantidad}
                    onChange={(e) => setMovCantidad(e.target.value)}
                  />
                </Col>
                <Col md={5}>
                  <Label>{movTipo === "Salida" ? "Cliente *" : "Cliente (opcional)"}</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={movCliente}
                    onChange={(e) => setMovCliente(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        (a.nombre_comercial || "") > (b.nombre_comercial || "") ? 1 : -1
                      )
                      .map((c) => (
                        <option value={c._id} key={c._id}>
                          {c.nombre_comercial}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Vendedor</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={movVendedor}
                    onChange={(e) => setMovVendedor(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {colaboradores
                      .sort((a, b) => ((a.nombre || "") > (b.nombre || "") ? 1 : -1))
                      .map((c) => (
                        <option value={c._id} key={c._id}>
                          {c.nombre} {c.apellido || ""}
                        </option>
                      ))}
                  </Input>
                </Col>
                {movTipo === "Salida" ? (
                  <Col md={2}>
                    <Label>Precio</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      step="any"
                      value={movPrecio}
                      onChange={(e) => setMovPrecio(e.target.value)}
                    />
                  </Col>
                ) : null}
              </Row>
              <Row className="mb-3 align-items-end">
                <Col md={9}>
                  <Label>Observaciones</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={movObs}
                    onChange={(e) => setMovObs(e.target.value)}
                  />
                </Col>
                <Col md={3}>
                  <Label>Total</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    disabled
                    value={new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(
                      (Number(movPrecio) || 0) * (Number(movCantidad) || 0)
                    )}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12}>
                  <Button color="success" onClick={guardaMov}>
                    Registrar {movTipo}
                  </Button>
                </Col>
              </Row>

              <h6>Historial — registra aquí el regreso de cada salida</h6>
              <Table size="sm" striped>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Cliente</th>
                    <th className="text-end">Cantidad</th>
                    <th className="text-end">Precio</th>
                    <th className="text-end">Total</th>
                    <th className="text-end">Regresó</th>
                    <th className="text-end">Pagó</th>
                    <th className="text-end">Pendiente</th>
                    <th>Observaciones</th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {movHistorial.length ? (
                    movHistorial
                      .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
                      .map((mv) => {
                        const esSalida = mv.tipo === "Salida";
                        const pend = Number(mv.pendiente || 0);
                        return (
                          <tr key={mv._id}>
                            <td>{mv.fecha}</td>
                            <td>
                              <Badge color={esSalida ? "danger" : "success"}>{mv.tipo}</Badge>
                            </td>
                            <td>{mv.clientes?.[0]?.nombre_comercial || ""}</td>
                            <td className="text-end">{mv.cantidad}</td>
                            <td className="text-end">
                              {esSalida && Number(mv.precio || 0) > 0
                                ? new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                  }).format(mv.precio)
                                : ""}
                            </td>
                            <td className="text-end">
                              {esSalida && Number(mv.total || 0) > 0
                                ? new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                  }).format(mv.total)
                                : ""}
                            </td>
                            <td className="text-end">{esSalida ? mv.devuelto || 0 : ""}</td>
                            <td className="text-end">{esSalida ? mv.pagadas || 0 : ""}</td>
                            <td className="text-end">
                              {esSalida ? (
                                pend > 0 ? (
                                  <b className="text-danger">{pend}</b>
                                ) : (
                                  <Badge color="success">Completa</Badge>
                                )
                              ) : (
                                ""
                              )}
                            </td>
                            <td>{mv.observaciones !== "NA" ? mv.observaciones : ""}</td>
                            <td className="text-center">
                              {esSalida && pend > 0 ? (
                                <>
                                  <Button
                                    size="sm"
                                    color="success"
                                    className="me-1"
                                    onClick={() => registraRegreso(mv)}
                                  >
                                    <i className="fas fa-undo"></i> Regresó
                                  </Button>
                                  <Button
                                    size="sm"
                                    color="primary"
                                    title="El cliente se quedó la muestra y la pagó"
                                    onClick={() => registraPago(mv)}
                                  >
                                    <i className="fas fa-dollar-sign"></i> Pagó
                                  </Button>
                                </>
                              ) : null}
                            </td>
                          </tr>
                        );
                      })
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center text-muted">
                        Sin movimientos
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default Muestras;
